{
  "settings" : {
    "calendar" : {
      "calendar_settings" : "Calendar Settings",
      "settings" : "Instellingen",
      "select_calendar_type" : "Type Select",
      "add_new_calendar_group" : "new Group Add",
      "add_new_equipment" : "Add new Equipment",
      "new_calendar" : "new Calendar",
      "calendar_group_description" : "Gebruik Calendar Group om meerdere kalenders effectief Sort en Group .",
      "group" : "Groep",
      "manage_your_calendars_and_groups" : "Manage je Calendars and Group",
      "groups" : "Group",
      "create_group" : "Create Group",
      "create_calendar" : "Kalender Create",
      "calendar_name" : "Naam kalender",
      "group_duration" : "Group Duration",
      "calendar_type" : "Type",
      "action" : "Actie",
      "round_robin" : "Roulatiesysteem",
      "event" : "Event",
      "group_name" : "Group",
      "room_name" : "Name Room",
      "group_description" : "Description Group",
      "calendar_url" : "Kalender- URL",
      "calendars" : "Kalenders",
      "date_updated" : "Updated Date",
      "status" : "Status",
      "action_dropdown" : "Keuzelijst Actie",
      "calendar_list" : "Services Members to",
      "edit" : "Bewerken",
      "duplicate" : "Dupliceren",
      "copy_embed_code" : "Copy Embed Code",
      "copy_permanent_link" : "Permanente LinkCopy",
      "copy_new_slug_link" : "Copy Scheduling Link",
      "copy_scheduling_link" : "Copy Scheduling Link (verouderd)",
      "deactivate_calendar" : "Suspend Calendar",
      "move_to_group" : "Move naar Group",
      "delete_calendar" : "Kalender verwijderen",
      "delete_group" : "Verwijderen",
      "delete_this_group" : "Deze Group verwijderen",
      "activate_calendar" : "Agenda trigger",
      "duration" : "Duur",
      "all" : "every",
      "draft" : "Concept",
      "inactive" : "Inactief",
      "active" : "Dynamic",
      "actions" : "activities",
      "rearrange_calendars" : "Calendars Reschedule",
      "deactivate_all_calendars_in_group" : "Suspend every Calendars in Group",
      "activate_all_calendars_in_group" : "trigger every kalenders in Group",
      "no_groups_found" : "Je Search heeft geen enkele Group opgeleverd.",
      "no_groups_in_location" : "Group Sort je kalenders Like Folder. Add Kalenders aan een Group en Share a Individual Scheduling Link, in het kader van Booker Select From meerdere kalenders.",
      "no_calendars_found" : "Aan de slag Via kalender Via Created new kalender.",
      "no_calendars_found_search" : "Je Search heeft geen kalenders opgeleverd.",
      "delete_calendar_message" : "You bent About om Agenda te verwijderen. When You Views wordt ook verwijderd om every its Appointment.",
      "delete_calendar_message_title" : "Deze kalender verwijderen?",
      "duplicate_calendar_message" : "You bent About naar de kalender Duplicate . Hierdoor wordt een new kalender Create met dezelfde Settings als de Selected kalender.",
      "duplicate_calendar_message_title" : "Deze kalender Duplicate ?",
      "no_calendars_found_title" : "Geen kalenders gevonden",
      "no_groups_in_location_title" : "No Group found",
      "delete_group_confirmation_title" : "Deze Group verwijderen?",
      "delete_group_confirmation" : "Weet je zeker dat je de Selected Group wilt verwijderen?",
      "delete_group_confirmation_checkbox_title" : "Members Calendars en Appointment verwijderen",
      "delete_group_confirmation_checkbox_description" : "Door deze optie te selecteren worden ook de agenda's in deze Group verwijderd, samen met every Appointment in die agenda's.",
      "group_status_message_title" : "{status} Calendars Group en every Members ?",
      "calendar_status_message_title" : "{status} deze kalender?",
      "calendar_status_message" : "You're About to {status} Calendar",
      "group_status_active_message" : "Weet je zeker dat je deze Group wilt trigger ? every kalenders binnen de Group wordt ook Enabled en beschikbaar om te boeken",
      "group_status_inactive_message" : "Weet je zeker dat je deze Group wilt Suspend ? every kalenders binnen de Group wordt ook Disabled en beschikbaar om te boeken",
      "coming_soon" : "Binnenkort beschikbaar",
      "select" : "Selecteren",
      "15mins" : "15 minuten",
      "cancel" : "Annuleren",
      "save" : "Archive",
      "create" : "Maken",
      "select_calendar_group" : "Calendar Group Select",
      "move_calendar_confirmation" : "Houd er Note dat de verouderde Link zou niet meer werken zodra You Continue met de Change. Bevestig Via het Checkbox.",
      "previously_called_unassigned" : " (Eerder genoemd als niet-toegewezen)",
      "scheduling_type" : "Type Select",
      "scheduling_type_description" : "Select een Calendar Type om uw kalender Configure en Customize hoe Appointment worden Scheduled.",
      "service_menu_name" : "Naam servicemenu",
      "template" : "Sjabloon",
      "select_template" : "Sjabloon selecteren",
      "group_url" : "URLGroup",
      "template_description" : "You hebt de now om de sjablonen van de Classic Of Neo voor de Group Select View",
      "rooms" : "Room",
      "rooms_name" : "Naam",
      "rooms_description" : "Beschrijving",
      "rooms_modal_description" : "Add Of Edit Room",
      "rooms_capacity" : "Total capaciteit",
      "no_rooms_in_location_title" : "No Room found",
      "no_rooms_in_location" : "Room found in deze Location",
      "no_equipments_in_location" : "Geen Equipment found in deze Location",
      "equipments" : "Uitrusting",
      "equipment_name" : "Naam",
      "equipment_name_search" : "Equipment naam",
      "equipment_description" : "Beschrijving",
      "equipment_modal_description" : "Add Of Operations and Equipment",
      "add_equipment" : "Add / Edit",
      "add_room" : "Edit Add /",
      "equipment_quantity" : "Total hoeveelheid",
      "equipment_outOfService" : "From bestelwagens",
      "no_equipments_in_location_title" : "Geen Equipment found",
      "delete_this_equipment" : "Deze Equipment verwijderen",
      "delete_this_rooms" : "Deze Room verwijderen",
      "delete_equipment_confirmation" : "Weet You zeker dat You deze Equipment wilt verwijderen? Dit wordt ook Deleted From every Third Party Calendars .",
      "delete_rooms_confirmation" : "Weet je zeker dat je deze Room wilt verwijderen? Dit wordt ook Deleted From every Third Party Calendars .",
      "add_new_calendar_equipments" : "Add new Equipment",
      "no_equipments_found" : "Je Search heeft geen overeenkomende Equipment opgeleverd.",
      "no_rooms_found" : "Je Search heeft geen overeenkomende Room opgeleverd.",
      "add_new_calendar_rooms" : "new Add",
      "rooms_disable" : "Room Disable",
      "equipments_disable" : "Disable",
      "equipments_activate" : "Equipment trigger",
      "rooms_activate" : "trigger Room",
      "create_equipments" : "Create",
      "create_rooms" : "Create Room",
      "select_calendar_rooms_title" : "Calendar Select",
      "select_calendar_rooms_description" : "You kunt meerdere kalenders Select om Affiliate met Room",
      "select_calendar_equipments_title" : "Calendar Select",
      "select_calendar_equipments_description" : "You kunt één kalender Select om Affiliate met de Equipment",
      "disable_equipment_title" : "{status} Equipment",
      "disable_room_title" : "{status} Room",
      "equipments_status_message" : "Weet You zeker dat You {status} deze wilt Equipment?",
      "rooms_status_message" : "Weet je zeker dat je {status} deze Room wilt?",
      "calendar_resource_disclaimer" : "Dit kan van invloed zijn op de serviceagenda's Availability On Members .",
      "equipment_disclaimer" : "Note: Als u Equipment later inschakelt, wordt deze automatisch Reconnect met kalenders waarmee hij Members is",
      "room_disclaimer" : "Note: Door de Room later in te schakelen, wordt deze automatisch Reconnect met kalenders waarmee hij Members is",
      "equipment_tab_name" : "Uitrusting",
      "rooms_tab_name" : "Room",
      "manage_your_rooms" : "Manage Room for Your Business",
      "manage_your_equipments" : "Manage voor Equipment Business",
      "select_service_calendar_description_equipments" : "You kunt meerdere serviceagenda's Select om Affiliate met Equipment",
      "select_service_calendar_description_rooms" : "You kunt meerdere serviceagenda's Select om Affiliate met Room",
      "service_menus" : "Servicemenu",
      "manage_your_calendars_groups_and_service_menus" : "Manage je agenda's, Group en servicemenu",
      "new_service_menu" : "Servicemenu Create",
      "deactivate_service_menu" : "Servicemenu Suspend",
      "delete_service_menu" : "Dit servicemenu verwijderen",
      "delete_service_menu_confirmation" : "Weet je zeker dat je dit servicemenu wilt verwijderen?",
      "service_menu_status_message_title" : "{status} dit servicemenu?",
      "service_menu_status_message" : "You bent About naar {status} servicemenu",
      "no_service_menus_in_location_title" : "Je aangepaste servicemenu Create",
      "add_new_service_menu" : "Add new Service Menu",
      "no_service_menus_in_location" : "Begin Via menu Service Created a new en voeg Group toe",
      "no_service_menu_found" : "Geen servicemenu gevonden",
      "no_service_menu_found_desc" : "Je Search heeft geen servicemenu's opgeleverd.",
      "apply" : "Apply",
      "troubleshoot_calendar" : "Troubleshoot Calendar",
      "round_robin_booking" : "Round Robin",
      "round_robin_description" : "Verdeelt Appointment in Group in een wisselend Sort.",
      "round_robin_example" : "Bijvoorbeeld: Sales , Onboarding -sessies.",
      "unassigned_booking" : "Agenda : Calendar",
      "unassigned_description" : "Voor fysieke Schedule occurrences zonder Host Relation.",
      "unassigned_example" : "Bijvoorbeeld: conferenties, Public seminars, beurzen.",
      "event_booking_alert_title" : "Belangrijk",
      "event_booking_alert_message" : "Dit type kalender heeft belangrijke verschillen",
      "event_booking_know_more" : "Meer info",
      "event_booking_tooltip_title" : "Belangrijke informatie:",
      "event_booking_tooltip_content" : "• Dynamische tools voor vergaderlinks worden niet ondersteund (bijv. Zoom/Google Meet/MS Teams)\n• Er kan geen gebruiker worden toegewezen\n• Gebeurtenissen worden standaard niet gesynchroniseerd met de agenda van een gebruiker\n• Slechts één Google Calendar kan worden gesynchroniseerd via Externe Sync\n• Conflicterende agenda's worden niet ondersteund",
      "class_booking" : "Klas boeken",
      "class_booking_description" : "Eén Host voldoet aan meerdere Members.",
      "class_booking_example" : "Courses : webinars, Group , online Courses.",
      "collective_booking" : "COLLECTIVE Booking",
      "collective_booking_description" : "Meerdere hosts komen samen op één Members.",
      "collective_booking_example" : "Bijvoorbeeld: Panelinterviews, commissiereviews.",
      "service_booking" : "Serviceboeking",
      "service_booking_description" : "Naadloze Schedule voor op service gebaseerde bedrijven.",
      "service_booking_example" : "Bijv.: Spa Appointment, Services, consulten.",
      "personal_booking" : "Persoonlijke boeking",
      "personal_booking_description" : "Schedule één-op-één gesprekken met een specifieke Group .",
      "personal_booking_example" : "Bijvoorbeeld: Vergaderingen met klanten, Private -consulten.",
      "personal" : "Persoonlijk",
      "explore_more_types" : "Ontdek meer Categories",
      "no_calendars_added" : "Nog geen kalenders – Collection One Up!",
      "no_calendars_added_description" : "Create je eerste kalender aan om makkelijk in Schedule .",
      "no_groups_added" : "Nog geen Group – Begin met organiseren!",
      "no_calendars_yet" : "Nog geen kalenders",
      "no_groups_yet" : "Nog geen Group",
      "no_calendars_access" : "Er zijn nog geen kalenders Created . Zodra een kalender is Created, komt deze here te staan. You If geen Access om een kalender aan Create - neem Contact op met uw Admin .",
      "no_groups_access" : "Er zijn nog geen Group Configure . Zodra een Group is Created, wordt deze here weergegeven. You If geen Access to Create a Group—Neem Contact op met uw Admin .",
      "no_groups_added_description" : "Gebruik Group om je agenda's gestructureerd Keep . Kalenders Add aan een Group en Share a Individual Group voor Simple boeken.",
      "group_success_message" : "Group is Created. You now kalenders Add aan deze Group.",
      "choose_calendars" : "Calendars Select",
      "do_it_later" : "Ik doe het later",
      "add_calendars_to_group" : "Kalenders Add aan Group",
      "select_calendars_to_add" : "Select every kalenders die You wilt Add aan Group {name}",
      "add_calendars" : "Add Kalender(s)",
      "continue" : "Doorgaan",
      "conflicting_calendars" : "Conflicterende kalenders",
      "conflicting_calendars_description" : "De Trailing kalenders zijn al onderdeel of Other Group. Wilt You ze Move naar uw new Group, <b>{name}</b>?",
      "group_associated_with" : "Group Current",
      "move_calendar_consent" : "I Enable deze kalenders in naar de new Group.",
      "calendars_moved_successfully" : "every the Selected kalenders zijn succesvol verplaatst naar {name}.",
      "new_group" : "new Group",
      "back" : "Terug",
      "share_otl" : "Share uw Availability op every Date met een unieke Link that Expires After a booking, voor een Manage Access.",
      "copied_to_clipboard" : "Gekopieerd naar klembord",
      "generate_link" : "new Generate Link",
      "generate_link_error" : "Kan geen eenmalige link genereren. Probeer het opnieuw",
      "share_schedule_link" : " De Scheduling Link wordt bepaald Via de Slug. Modify the Slug, en de Scheduling Link past zich automatisch aan de wijziging aan.",
      "share_permanent_link" : "Ideaal voor Funnels, Website Redirects, Of Advertisements, de vaste Link blijft constant, onaangetast. Via Slug Dynamic.",
      "copy" : "Kopiëren",
      "share_embed_code" : "Location deze Code in uw HTML op de plaats waar You uw Widget {embedType} wilt weergeven.",
      "scheduling_link" : "Scheduling Link",
      "permanent_link" : "Permanente Link",
      "one_time_link" : "LinkDate",
      "embed_code" : "Embed Code",
      "loading" : "Aan het laden...",
      "share_group" : "Share Group",
      "edit_group" : "Edit Group",
      "more_options" : "Meer Options",
      "share_calendar" : "Calendar Share",
      "edit_calendar" : "Calendar Edit",
      "troubleshoot_calendar_link" : "Troubleshoot Calendar",
      "calendar_config_success" : "Je hebt je persoonlijke kalender/ Group geconfigureerd",
      "close" : " Close",
      "added_calendars" : "Kalender(s) toegevoegd",
      "select_calendars" : "Calendar(s) Select",
      "settings_confirmation" : "Bevestig deze om Continue Dynamic.",
      "consent_checkbox_title" : "Ik begrijp en ga akkoord met deze Dynamic",
      "confirm" : "Bevestigen",
      "create_group_access_disabled" : "You hebt geen Authorization om een Group Create . Your Admin voor Access .",
      "create_calendar_access_disabled" : "Je hebt geen Authorization om een kalender Create . Your Admin voor Access .",
      "preview_booking_widget" : "Booking Widget Preview",
      "share_service_menu" : "Service Menu Share",
      "back_message" : "Back naar Agenda 'List",
      "service_calendars" : "Servicekalenders",
      "owned_by" : "Eigenaar Via",
      "owned_by_anyone" : "Iedereen",
      "owned_by_me" : "Ikzelf",
      "all_groups" : "every Group",
      "all_calendars" : "every Calendars",
      "not_grouped" : "Niet gegroepeerd",
      "delete_group_desc" : "Weet je zeker dat je deze Group wilt verwijderen? Hierdoor worden ook every Members met deze Group verwijderd.",
      "calendar_listing_title" : "Kalendervermelding",
      "calendar_group_name" : "Naam kalender/ Group",
      "success" : "Succes",
      "my_calendar" : "mijn-kalender"
    },
    "preferences" : {
      "preferences" : "Settings",
      "my_preferences" : "My Preference",
      "account_preferences" : "Preferences Account",
      "user_preferences" : "Operator Settings",
      "set_preferences" : "Settings Collection voor uw Account.",
      "scheduling_options" : "In Options",
      "meeting_location" : "Conferencing Location",
      "zoom" : "Zoom",
      "save_preferences" : "Archive Settings",
      "in_app_preferences" : "in-app Settings",
      "set_start_day" : "Settings Day voor het Collection van Like voor de app",
      "view_options" : "Options View",
      "services" : "Services",
      "feature_toggle_aria" : "Functieschakelaar",
      "week_starts_on" : "Week Starts On",
      "sunday" : "Zondag",
      "widget_preferences" : "Widget Settings",
      "set_widget_language" : "Collection Settings Like Language for Widget",
      "language_and_region" : "Language and State",
      "language" : "Taal",
      "english" : "Dutch",
      "time_format" : "Tijdsformaat",
      "time_format_value" : "13.30 PM",
      "monday" : "Monday",
      "custom_meeting_location" : "Custom Conferencing Location",
      "view_appointments_in_1" : "Afspraken bekijken in",
      "timezone_uses_details_1" : "We zullen deze Tijdzone gebruiken om Afspraaktijden in de app en in uw afspraakgerelateerde e-mails weer te geven — speciaal voor U. Het heeft geen invloed op uw beschikbaarheid of de manier waarop anderen bij u boeken.",
      "business_timezones_1" : "Tijdzone van bedrijf",
      "business_timezones_tooltip_1" : "Bericht: Door deze optie te kiezen, zorgt u ervoor dat uw weergavevoorkeur overeenkomt met de geselecteerde bedrijfstijdzone. Als de Tijdzone van het Bedrijf verandert, wordt uw weergavetijdzone automatisch aangepast om overeen te komen.",
      "recommended_timezones" : "Aanbevolen tijdzones",
      "all_timezones" : "Alle tijdzones"
    },
    "availability" : {
      "availability" : "Beschikbaarheid",
      "my_availability" : "My Availability",
      "my_availability_and_booking_rules" : "Beschikbaarheid en Boekingsregels",
      "my_availability_and_booking_rules_description" : "Configureer uw beschikbaarheid en stel in hoe en wanneer deze kalender boekingen accepteert, inclusief vergaderintervallen, limieten en andere planningsvoorkeuren.",
      "account_availability" : "Beschikbaarheid Account",
      "timezone" : "Tijdzone",
      "working_hours" : "Werkuren",
      "set_recurring_hours" : "Recurring Collection hour for Conferencing",
      "select_one" : "Selecteer één optie",
      "sunday" : "Zondag",
      "monday" : "Monday",
      "tuesday" : "Dinsdag",
      "wednesday" : "Woensdag:",
      "thursday" : "Donderdag",
      "friday" : "Vrijdag",
      "saturday" : "Saturday",
      "widget_preferences" : "Widget Settings",
      "set_widget_language" : "Collection Settings Like Language for Widget",
      "language_and_region" : "Language and State",
      "language" : "Taal",
      "english" : "Dutch",
      "copy_to_all" : "Copy to every",
      "save_availability" : "Archive Availability",
      "add_time" : "Add Date",
      "to" : "Naar",
      "select_time" : "Date Select",
      "add_user" : "Add Operator",
      "accessRestricted" : {
        "header" : "Access Private",
        "message" : "Je bent geen onderdeel of dit Account. Om Access te krijgen, Add u op deze Account Via Agency > Group > Edit Group Members en wijst u de Account toe onder 'Rollen en Permissions'",
        "contact_admin" : "Deze Page is alleen Public voor beheerders. Neem Contact op met uw Admin voor hulp.",
        "button_text" : "Settings naar Agency"
      },
      "schedule" : {
        "edit_schedule" : "Agenda bewerken",
        "schedule_name" : "Naam agenda",
        "schedule_name_required" : "Naam agenda is vereist",
        "timezone" : "Tijdzone",
        "timezone_placeholder" : "Selecteer één optie",
        "start_time" : "Begintijd",
        "end_time" : "Eindtijd",
        "add_availability_hour" : "Beschikbaarheidsuur toevoegen",
        "remove_availability_hour" : "Beschikbaarheidsuur verwijderen",
        "unavailable" : "Niet beschikbaar",
        "schedule_created" : "Agenda gemaakt",
        "schedule_updated" : "Agenda bijgewerkt",
        "calendars_selected" : "{count} Kalenders",
        "calendars_selected_multiple" : "{count} kalenders",
        "select_users_placeholder" : "Zoeken naar gebruikers",
        "edit_default_schedule" : "Deze planning bewerken",
        "customize_event_type_schedule" : "Agenda alleen voor deze kalender aanpassen",
        "multi_user_description" : "<b>{count} gebruikers</b> zijn geselecteerd, werk hun beschikbaarheid voor <b>{calendar}</b> bij",
        "selected_calendar" : "geselecteerde kalender",
        "edit_schedule_alert" : "Updates die hier worden aangebracht, zijn van toepassing op",
        "schedule" : "Inplannen",
        "no_availability" : "Geen beschikbaarheid",
        "date_specific_hours_show_more" : "meer",
        "date_specific_hours_show_less" : "minder",
        "date_specific_hours_recurring_meetings_enabled" : "Datumspecifieke uur kunnen niet worden toegevoegd omdat deze planning is gekoppeld aan een kalender met ingeschakelde Terugkerend vergaderingen. Schakel Terugkerende vergaderingen uit om door te gaan.",
        "recurring_incompatible_with_date_hours" : "Terugkerende vergaderingen kunnen niet worden ingeschakeld omdat de agenda van de Gebruiker datumspecifieke uren heeft, wat incompatibel is.",
        "incompatible_schedule_with_recurring" : "De agenda {user} bevat datumspecifieke uren, wat niet compatibel is met terugkerende vergaderingen.",
        "incompatible_schedule_with_recurring_calendar" : "De agenda bevat datumspecifieke uren, wat onverenigbaar is met terugkerende vergaderingen.",
        "recurring_meetings_enabled_multi_user" : "Terugkerende vergaderingen vereisen slechts één toegewezen groepslid en hun agenda mag geen datumspecifieke uren toevoegen.",
        "weekdays" : "Weekdagen, {timeRange}",
        "weekdays_hours_vary" : "Weekdagen, uren variëren",
        "weekend" : "Weekend, {timeRange}",
        "weekend_hours_vary" : "Weekend, uren variëren",
        "days_hours_vary" : "{days}, uren variëren",
        "date_specific_hours_tab_name" : "Datumspecifieke uren",
        "date_specific_hours" : "{count} datumspecifieke uren",
        "date_specific_hours_1" : "1 datumspecifiek uur",
        "weekly_hours" : "Wekelijkse Uren",
        "custom_schedule" : "Aangepaste agenda",
        "select_schedule" : "Klik op een agenda",
        "no_schedules_found" : "Geen planningen gevonden",
        "untitled" : "Zonder titel",
        "error_updating_schedules" : "Fout tijdens het bijwerken van schema's",
        "daily" : "Dagelijks",
        "weekly" : "Wekelijks",
        "monthly" : "Maandelijks",
        "custom" : "Aangepast",
        "this_is_required" : "Dit is vereist",
        "search" : "Zoeken",
        "edit_hours" : "Uren Bewerken",
        "schedule_name_duplicate" : "Er bestaat al een agenda met deze naam",
        "delete_schedule_title" : "Agenda '{scheduleName}' verwijderen?",
        "delete_schedule_description" : "Deze actie kan niet ongedaan worden gemaakt. Weet u zeker dat u wilt doorgaan?",
        "delete_schedule_negative_text" : "Annuleren",
        "delete_schedule_positive_text" : "Ja, verwijderen",
        "active_on" : "Actief op",
        "weekly_working_hours" : "Wekelijkse werkuren",
        "weekly_working_hours_subtext" : "Selecteer de dagen en tijden waarop u werkt",
        "copy_availability_hour" : "Beschikbaarheidsuur kopiëren",
        "mins" : "Minuten",
        "hours" : "Uren"
      }
    },
    "connections" : {
      "connections" : "Verbindingen",
      "connect" : "verbinden",
      "conferencing" : "Bijeenkomst",
      "my_connections" : "Mijn verbindingen",
      "account_connections" : "Account",
      "connection_preferences" : "Connection Settings",
      "manage_calendars_conferencing_channels" : "Kanalen Manage Calendars en Conferencing",
      "main_integration_calendar" : "Integration Calendar PRIMARY",
      "event_integration_calendar" : "occurrences On a System Calendar that You bent een onderdeel of , Created ook Created On deze geïntegreerde kalender",
      "2way_sync" : "2-Way Sync: Create System occurrences From occurrences geboekt On de geïntegreerde kalender PRIMARY",
      "calendars" : "Kalenders",
      "google" : "Google",
      "outlook" : "Outlook",
      "check_for_conflicts" : "Check Mark voor conflicten",
      "choose_accounts_to_connect" : "Select welk Account You wilt koppelen",
      "payments" : "Betalingen",
      "stripe" : "Stripe",
      "ads" : "Advertenties",
      "local_service_ads" : "Advertenties voor lokale service",
      "fire_workflow" : "Fire Workflow Triggers voor occurrences geboekt Via 2-way Sync",
      "connect_google_outlook" : "Koppel uw Google/Outlook/iCloud Account om de PRIMARY Calendar te Select .",
      "execute_automation" : "Automatisering uitvoeren",
      "save" : "Archive",
      "lsa" : "Advertenties voor lokale service",
      "no_write_access" : "Je kunt niet schrijven Access tot deze kalender",
      "connection_remove_confirmation" : "You bent About om deze Integration te Extract",
      "active" : "Dynamic",
      "icloud" : {
        "title" : "iCloud Integration",
        "description" : "Twee-stapsverificatie en een app-specifiek password zijn Required om uw Account te koppelen.",
        "email" : "iCloud Email address",
        "password" : "iCloud-wachtwoord",
        "connect" : "Verbinden",
        "cancel" : "Annuleren"
      }
    }
  },
  "appointment_modal" : {
    "select_a_contact" : "Contact Select",
    "start_time" : "Date",
    "unassigned" : "Niet toegewezen",
    "end_time" : "End Date",
    "search_by_name_email_phone_or_company" : "Search Via name, Email, Phone Of Business",
    "add_new" : "Add new",
    "pick_from_available_contacts" : "Of Select From Available Friends",
    "book_appointment" : "Appointment Book",
    "add_blocked_off_time" : "Add Geblokkeerd Disabled Date",
    "recommended_timezones" : "Aanbevolen tijdzones",
    "all_timezones" : "every tijdzones",
    "calendar" : "Kalender",
    "repeat" : "Herhalen",
    "date_and_time" : "Date en Date",
    "close" : "Close",
    "team_member" : "Group",
    "recurring_booking" : "Recurring Booking",
    "one_slot_booking" : "Een tijdsperiode boeken",
    "event_type" : "Type gebeurtenis",
    "occurrences_booked" : "occurrences worden geboekt",
    "repeats" : "Herhalingen",
    "booking_details" : "Details boeking",
    "showing_slots_in_this_timezone" : "Tijdsperiodes in deze tijdzone Showing :",
    "update_contact_tz" : "Werk ook de tijdzone van de Contact bij",
    "date" : "Datum",
    "slot" : "slot",
    "calendar_default" : "Kalender Default",
    "custom" : "Aangepast",
    "meeting_notes" : "(eg) Conferencing -notities voor onze aankomende Appointment",
    "out_of_office" : "(bijv.) From -kantoor voor de Week!",
    "standard" : "Standaard",
    "appointment_title" : "Appointment Title",
    "event_title" : "Event Title",
    "appt_with_bob" : "(bijv.) Afspraak met Bob",
    "vacation" : "(bijv.) Vakantie",
    "show_notes" : "Show",
    "hide_notes" : "Hide Notities",
    "additional_preferences" : "Aanvullende Settings",
    "meeting_location" : "Conferencing Location",
    "appointment_status" : "StatusAppointment",
    "appt_description" : "Appointment",
    "recurring_details" : "DetailsRecurring",
    "event_description" : "Event",
    "in_contact_timezone" : "in de tijdzone van contactpersoon",
    "vacation_message" : "Ga je On vakantie? Disabled Date nemen? Blokkeer Disabled Date On je agenda om te voorkomen dat Customers From booking Appointment Current Appointment blijft On je agenda).",
    "contact" : "Contact",
    "delete" : "Verwijderen",
    "cancel" : "Annuleren",
    "back" : "Terug",
    "pick_available_contacts" : "Of Select From Available Friends",
    "no_contacts_found" : "Geen Friends found",
    "found" : "gevonden",
    "select_one" : "Select One",
    "tz_tooltip" : "Dit is alleen van You ; zoals Appointment Appointment enz . in uw Outbound Communication met uw Customers Of Customers. Het zet de bovengenoemde Details om naar hun lokale Date.",
    "meeting_location_tooltip" : "De Conferencing Location wordt Collection zoals geconfigureerd in de kalender.",
    "appt_meeting_location_tooltip" : "De Operator kan de specifieke Conferencing Collection voor de Appointment.",
    "gmeet_tooltip" : "Zorg Create dat de respectieve Group Members een Google Calendar Collection als PRIMARY kalender heeft",
    "zoom_tooltip" : "Zorg Create dat Zoom is geïntegreerd in de respectieve Group",
    "enter_meeting_location" : "Enter Conferencing Location",
    "save_appointment" : "Archive Appointment",
    "save_event" : "Archive",
    "search_contacts" : "Search Via name, Email, Phone Of Business",
    "recurring_slots" : "{recurringSlotsLength}/{count}",
    "custom_timezone" : "Custom Timezone",
    "system_timezone" : "Tijdzone System",
    "contact_timezone" : "Tijdzone Contact",
    "account_timezone" : "Tijdzone Account",
    "an_error_occurred" : "Er is een fout opgetreden"
  },
  "popup" : {
    "calendar" : "Kalender",
    "appointment_owner" : "Owner Appointment",
    "source" : "Bron",
    "booked_by" : "Geboekt Via",
    "view_activity_log" : "Activity Log View",
    "status" : "Status",
    "cancel_appointment" : "Appointment Cancel",
    "cancel_all" : "every Cancel",
    "google_event" : "Google Event",
    "outlook_event" : "Outlook Event",
    "blocked_slot" : "Blocked Off slot",
    "appointment" : "Afspraak:",
    "confirmed" : "Bevestigd",
    "unconfirmed" : "Onbevestigd",
    "cancelled" : "Geannuleerd",
    "showed" : "Showed",
    "no_show" : "No-show",
    "invalid" : "Ongeldig",
    "more" : "Meer",
    "less" : "Minder",
    "edit" : "Bewerken",
    "reschedule_all" : "Reschedule every",
    "guests" : "Gast(en)",
    "guest_count" : "Guest(s )"
  },
  "create_calendar" : {
    "calendar_name" : "Naam kalender",
    "calendar_logo" : "Logo",
    "select_team_member" : "Group Select",
    "select_single_team_member" : "Teamlid selecteren",
    "eg_outbound_reach" : "(bijv.) Uitgaande bereik",
    "description" : "Beschrijving",
    "amount" : "Bedrag",
    "description_placeholder" : "Beschrijving schrijven",
    "meeting_duration" : "Conferencing Duration",
    "meeting_location" : "Vergaderlocatie",
    "seats_per_class" : "Seats per Class",
    "group" : "Groep",
    "custom_url" : "Custom URL",
    "meeting_invite_title" : "Conferencing Title",
    "event_color" : "Color and Event",
    "availability_type" : "Type Availability",
    "new_calendar" : "new Calendar",
    "add_description" : "Add Description",
    "remove_description" : "Extract Description",
    "booking_availability" : "Beschikbaarheid boeken",
    "slug_tooltip" : "Customize de URLvan de Booking Widget aan",
    "meeting_location_tooltip" : "Left zijn Showed in de kalender en You Enable van een Location om dingen Event Conferencing Add .",
    "advanced_settings" : "Geavanceerde Settings",
    "show_more_schedule" : "Meer tonen",
    "show_more_helper_text" : "Om uw bedrijfsuren verder aan te passen, gaat u naar de geavanceerde instellingen",
    "reschedule_preference" : "Reschedule",
    "reschedule_preference_subtext" : "Als een {contactLabel} een afspraak opnieuw inplant:",
    "reassign_through_round_robin" : "Opnieuw toewijzen Via Round Robin",
    "keep_same_assinged_user" : "Owner Appointment Keep",
    "new_appointment_preference" : "new Appointment Preference",
    "new_appointment_preference_text" : "Boek altijd met de toegewezen gebruiker van {contactLabel}",
    "new_appointment_preference_subtext" : "Boek nieuwe afspraken met de toegewezen gebruiker van de {contactLabel} in plaats van gebruik te maken van round-robin planning.",
    "cancel" : "Annuleren",
    "confirm" : "Bevestigen",
    "service_calendar_name" : "Naam service",
    "service_logo" : "Logo",
    "service_select_team_member" : "Select Staff Members",
    "service_duration" : "Duur service",
    "appointment_invite_title" : "Appointment Invite Title",
    "payment_placeholder" : "Voer een Description in die wordt weergegeven aan de Operator en hem/haar op de hoogte houdt About de betaling",
    "deposit_amount" : "Aanbetalingsbedrag",
    "collect_deposit_amount" : "Incomplete betaling accepteren",
    "percentage" : "Percentage",
    "total_amount" : "Totaal bedrag",
    "enter_meeting_location" : "Voer de vergaderlocatie in",
    "accept_payments" : "Betalingen accepteren",
    "aria" : {
      "should_accept_payment" : "Moet betaling accepteren"
    },
    "calendar_name_tooltip" : "Naam van de kalender die moet worden weergegeven On the Booking Widget",
    "booking_availability_tooltip" : "Collection van de dagen en hour waarop boekingen kunnen worden gemaakt. Dit zijn Time Window Default Weekly Business hour voor Operator When",
    "select_team_member_tooltip" : "Select de Group die deze Conferencing zouden nemen",
    "seats_per_class_tooltip" : "Collection van de Max number of Members kan deze Class worden Book . Zodra every Seats is gevuld, is de Time Window niet meer beschikbaar om te boeken",
    "meeting_color" : "Conferencing Color",
    "meeting_duration_tooltip" : "This Fixed de Length of je Conferencing, bepaalt hoe lang het zal last"
  },
  "calendar_advanced" : {
    "general" : {
      "quick_tip" : "Snelle tip",
      "timezone_change_tip" : "Date kunnen op elk moment Dynamic zijn onder Date Zone Settings",
      "save" : "Archive",
      "close" : "Close",
      "meeting_details" : "DetailsConferencing",
      "availability" : "Beschikbaarheid",
      "forms_and_payment" : "Formulieren en betaling",
      "notifications_and_additional_options" : "Reminder en aanvullende Options",
      "connections" : "Verbindingen",
      "customizations" : "Aanpassingen",
      "create" : "Maken",
      "edit" : "Bewerken",
      "equipments" : "Room & Equipment",
      "service_details" : "Details",
      "saving_changes" : "Just not minute — Saving de laatste Dynamic...",
      "calendar_id": "Agenda-id",
      "saveCalendarSuccess": "Agenda succesvol opgeslagen"
    },
    "meeting_details" : {
      "meeting_location" : "Conferencing Location",
      "enter_meeting_location" : "Enter Conferencing Location",
      "click_to_upload" : "click om te Upload",
      "square" : "Vierkant",
      "circle" : "Cirkel",
      "remove_logo" : "Extract Logo",
      "meeting_invite_title_tooltip" : "Dit is de Title voor de Calendar Showed and in van Third Party Calendars",
      "event_color_tooltip" : "Select a Color voor deze boeking Event. Kleuren worden gesynchroniseerd met occurrences in Google Agenda.",
      "enter_a_name" : "Voer een naam in",
      "enter_an_event_title" : "Voer een Event in",
      "high_priority" : "Hoge Priority",
      "medium_priority" : "Average Priority",
      "low_priority" : "Lage Priority",
      "priority" : "Prioriteit",
      "custom" : "Aangepast",
      "zoom_not_added" : "De Operator heeft nog geen Zoom Account gekoppeld",
      "opt_avail" : "Optimaliseren voor Availability",
      "opt_equal" : "Optimaliseren voor gelijke Delivery",
      "team_members" : "Group Select",
      "team_members_location" : "Select Group Members & Assign Conferencing Location",
      "team_member" : "Group Select",
      "team_member_location" : "Select Group Members & Assign Conferencing Location",
      "meeting_location_required" : "Conferencing Location is Required",
      "meeting_details" : "DetailsConferencing",
      "meeting_details_description" : "Dit zijn de Details die Showed zijn in de kalender List Page.",
      "or_drag_and_drop" : "Van Drag en neerzetten",
      "service_details" : "Details",
      "team_member_disabled_recurring_tooltip" : "Recurring meetings Enable slechts één Group Members. Om meerdere Group Members Disable Add , Recurring",
      "team_member_disabled_class_booking_tooltip" : "Members kan slechts één Group worden toegevoegd aan een Class Service Calendar",
      "advanced_settings" : "Geavanceerde Settings",
      "enable_contact_assigned_to_setting" : "Om deze Setting in Enable , moet de Form de eerste zijn in de Widget Sort. Plan de Widget Sort From het tabblad Formulieren en betaling Reschedule .",
      "reschedule_preference_setting_tooltip" : "Selecteer aan wie de afspraak moet worden toegewezen wanneer een {contactLabel} de afspraak opnieuw plant vanuit de widget boekingen.",
      "appointment_preference_tooltip" : "Selecteer of nieuwe afspraken altijd moeten worden geboekt bij de aan de {contactLabel} toegewezen gebruiker. Als een {contactLabel} een toegewezen gebruiker heeft, krijgt die gebruiker de voorkeur; anders wordt het volgens het Round-robin-principe toegewezen. Tip: Schakel \"Personeelsselectie toestaan\" uit om te voorkomen dat boekers het personeelslid in de widget-boekingen kunnen wijzigen.",
      "add_location" : "Add Location",
      "multiple_locations_neo" : "Meerdere Conferencing Address worden alleen ondersteund Via de Neo Widget.",
      "make_owner" : "Owner Create",
      "only_one_team_member" : "Members is slechts één Group toegestaan When meerdere Address worden toegevoegd.",
      "ask_the_booker_error_message" : "Ask the Booker Location bestaat al",
      "enter_location" : "Enter Location Value",
      "enter_display_label" : "Voer Display in",
      "add_display_label" : "Display Add Add",
      "multiple_location_support_message" : "Meerdere Conferencing Address worden alleen ondersteund Via de Neo Widget.",
      "only_one_team_member_personal_calendar" : "Er is slechts één Group Members toegestaan voor een persoonlijke boeking ",
      "ms_teams_not_added" : "De Operator heeft nog geen Microsoft Group Account gekoppeld",
      "enable_new_appt_preference" : "new Enable Appointment",
      "enable_new_appt_preference_desc" : "Als u '<b>Altijd boeken met de toegewezen gebruiker van de {contactLabel}</b>' inschakelt, wordt het <b>formulier</b> automatisch ingesteld als de eerste stap in de widget-volgorde.",
      "location_exists_toast" : "Conferencing Location al toegevoegd",
      "not_supported_with_multiple_team_members" : "Niet ondersteund met Members Group",
      "not_supported_personal_calendar" : "Niet ondersteund in persoonlijke kalender",
      "not_supported_class_booking" : "Niet ondersteund in de Class Service Calendar",
      "not_supported_collective_booking" : "Niet ondersteund in COLLECTIVE Calendar",
      "not_supported_service_booking" : "Niet ondersteund in de Service Calendar",
      "not_supported_round_robin" : "Niet ondersteund in Round Robin kalender",
      "not_supported_event" : "Niet ondersteund in Event",
      "calendar_logo_tooltip" : "Select een Logo om Showed te zijn On the Booking Widget",
      "calendar_name_tooltip" : "Naam van de kalender die moet worden weergegeven On the Booking Widget",
      "description_tooltip" : "Beschrijf wat de kalender is About, om weer te geven On de Booking Widget",
      "group_tooltip" : "You kunt deze kalender toewijzen aan een Group (If Created). Operator Access the Group Link kan From every in die Group zoeken en Book",
      "custom_url_tooltip" : "Customize de URLvan de Booking Widget aan",
      "meeting_color_tooltip" : "Select a Color voor deze boeking Event. Colors Sync to afrondingsen in Google Calendar",
      "add_display_label_tooltip" : "Er zijn meerdere Location Options beschikbaar om de Location te maskeren",
      "meeting_location_tooltip" : "Select hoe Of waar de Conferencing naartoe gaat Location",
      "team_members_location_tooltip" : "Select de Group die deze Conferencing zou nemen",
      "meeting_distribution" : "Conferencing Delivery",
      "meeting_distribution_tooltip" : "Select hoe Afspraken worden verdeeld Members uw Selected Group — Availability On Gelijke Delivery",
      "opt_avail_tooltip" : "Wijs vergaderingen Members die beschikbaar is op de Selected Date, of Previous boekingen. Maximaliseert het gebruik van Open slot en boeken Success Frequency",
      "opt_equal_tooltip" : "Publish vergaderingen Equally onder every Group Members Via tracking Previous boekingen. Stelt billijkheid boven Availability",
      "priority_tooltip" : "Collection When verschillende Group Members Even . Members met een hogere Priority worden als eerste in aanmerking genomen voor boekingen, Follow Via Average en Low Priority Members",
      "contact_routing_preference" : "Preference Contact",
      "contact_routing_preference_tooltip" : "Definieer hoe nieuwe en terugkerende {contactsLabel} aan groepleden worden toegewezen - via Round-robin of hun oorspronkelijke eigenaar",
      "team_members_location_owner_tooltip" : "De PRIMARY Operator , eigenaar van de Conferencing en zorgt voor de laatste Conferencing Location",
      "owner" : "Eigenaar",
      "upload_from_system" : "Uploaden vanuit systeem",
      "choose_from_media_storage" : "Kies uit mediaopslag",
      "only_one_team_member_allowed" : "Slechts één Groep Leden is toegestaan",
      "at_least_two_team_members_required" : "Er zijn minimaal 2 teamleden vereist",
      "at_least_one_team_member_required" : "Er is minimaal één teamlid vereist"
    },
    "availability" : {
      "my_availability" : "My Availability",
      "set_availability" : "Collection uw Availability voor de kalender here.",
      "standard" : "Standaard",
      "custom" : "Aangepast",
      "to" : "Aan",
      "copy_to_all" : "Copy to every",
      "add_time" : "Add Date",
      "recurring_meeting" : "Recurring Conferencing",
      "recurring_info" : "Slechts één Operator per kalender voor Recurring -boeking",
      "repeat" : "Herhalen",
      "times_to_repeat" : "times naar Repeat",
      "slots_unavailable" : "Als er geen tijdsperiodes beschikbaar zijn?",
      "overlap_status" : "Status van overlappende Appointment ",
      "meeting_interval" : "Vergaderinterval",
      "meeting_duration" : "Conferencing Duration",
      "minimum_scheduling" : "Min",
      "date_range" : "Date Scopes",
      "maximum_bookings_per_day" : "Max. boekingen per Day",
      "maximum_bookings_per_slot" : "Max. boekingen per slot",
      "maximum_bookings_per_slot_per_user" : "Max. boekingen per slot (per Operator)",
      "seats_per_class" : "Seats per Class",
      "pre_buffer_time" : "Pre BUFFER Date",
      "post_buffer_time" : "BUFFER Date Share",
      "pre_buffer_tooltip" : "Pre-Buffer is extra Date die kan worden toegevoegd Voor an Appointment, Enable voor extra Date om Ready te worden",
      "post_buffer_tooltip" : "Post-buffer is extra Date die kan worden toegevoegd After an Appointment, Enable voor extra Date om af te sluiten",
      "buffer_time" : "BUFFER Date",
      "daily" : "Dagelijks",
      "weekly" : "Wekelijks",
      "monthly" : "Maandelijks",
      "skip_booking" : "Boeking overslaan niet-beschikbare tijdsperiodes",
      "continue_booking" : "Doorgaan met boeken",
      "book_next_available" : "Next beschikbare slot Book",
      "confirmed" : "Bevestigd",
      "unconfirmed" : "Onbevestigd",
      "enter_valid_hours" : "Voer een geldig Open hour in",
      "enter_valid_avail" : "Voer een Custom Availability in",
      "availability_type_tooltip" : "Select Default Availability voor Monthly boekingen Weekly. Alleen Custom voor boekingen Select beschikbaar On specifieke data.",
      "meeting_interval_tooltip" : "Conferencing Seconds geeft het bedrag of Date weer tussen boekingen die Showed zijn in de kalender. Voor een Top of every hour van 30 Min die beschikbaar zou moeten zijn, is de Seconds 1 uur. Voor een 30 Min Event die every 30 minuten beschikbaar zou moeten zijn, zou de Seconds 30 minuten zijn.",
      "date_range_tooltip" : "occurrences kunnen de Next n dagen worden Scheduled .",
      "maximum_bookings_per_day_tooltip" : "Max. number toegestane of per Day On deze kalender",
      "maximum_bookings_per_slot_tooltip" : "Max number of Appointment toegestaan per slot voor de Operator ( If the number of Appointment overschreden voor in Next slot Book slot Opportunity ).",
      "add_days" : "Dagen Add",
      "month_on_day" : "Monthly On Day",
      "month_on_last_day" : "Monthly On",
      "day" : "Dag",
      "week" : "Week",
      "month" : "Maand",
      "mins" : "Minuten",
      "hours" : "Uren",
      "days" : "Dagen",
      "weeks" : "Weken",
      "months" : "Maanden",
      "meeting_interval_error" : "De Conferencing Seconds moet tussen 5 minuten en 12 hour liggen",
      "meeting_duration_error" : "De Conferencing Duration moet tussen 1 Min en 12 hour liggen",
      "buffer_time_error" : "BUFFER Date moet minder dan 12 hour zijn",
      "appointment_interval" : "Seconds Appointment",
      "appointment_duration" : "Appointment",
      "maximum_appointments_per_day" : "Max Appointment per Day",
      "subTitle" : "Select the Date to Collection specific hour",
      "heading_1" : "Weekly Available hours",
      "scheduling_availability_heading" : "Beschikbaarheid van boekingen",
      "tooltip_1" : "schedule van uw Weekly Availability Collection . Dit is uw Default hour dat consequent wordt toegepast On Weekly",
      "heading_2" : "When bent You beschikbaar?",
      "unavailable_label" : "Niet beschikbaar",
      "tooltip_2" : "Modify je schedule voor specifieke data. Monthly Weekly hour overschrijven Via markering Availability Of onbeschikbaarheid voor Selected datums.",
      "date_specific_level" : "Add Date specific hour",
      "specific_hours_button" : "Datum Specifieke uren",
      "specific_hours_description" : "Overschrijf uw beschikbaarheid voor specifieke datums wanneer uw openingstijden afwijken van uw normale wekelijkse uren.",
      "overlap_error" : "Date mogen niet overlap",
      "apply" : "Apply",
      "copy_times_to" : "times Copy",
      "no_date_specific_heading" : "Geen Date specifieke Date toegevoegd",
      "no_date_specific_description" : "You Extract specifieke Date en Date Add aan uw Availability",
      "recurring_disabled_conditions_tooltip" : "Recurring meetings zijn Disabled. Om ze te trigger , moet de kalender slechts Members Group hebben en geen datumspecifiek hour Incomplete betaling toevoegen.",
      "date_specific_hours_disabled_conditions_tooltip" : "Om een datumspecifiek hour Add , moet u ervoor zorgen dat Recurring vergaderingen zijn Disabled.",
      "recurring_disable_event_calendar_conditions" : "Recurring meetings zijn Disabled. Om ze trigger, moet je ervoor zorgen dat er geen datumspecifiek hour van Incomplete is toegevoegd.",
      "service_duration" : "Duur service",
      "service_interval" : "Service Seconds",
      "service_interval_tooltip" : "The Conferencing Seconds Fixed hoe vaak boekingen worden weergegeven On de kalender. Voor Model, voor een 30 minute Event , betekent een Seconds van 1 hour dat er slots every hour verschijnen. Een Seconds van 30 minute betekent dat er every 30 minuten verschijnen.",
      "service_duration_tooltip" : "This Fixed the Length of your Appointment, Bepaald hoe lang het last zal zijn.",
      "minimum_scheduling_tooltip" : "This Fixed the Min Date Required om Book en Appointment Via de Widget. Voor Model, If Collection to 4 hour kan Appointment niet worden geboekt binnen 4 hour of hun Date; boekingen moeten minimaal 4 hour in tevoren worden gemaakt.",
      "look_busy_title" : "Druk lijken",
      "look_busy_helper_text" : "Hide a Percentage of je beschikbare Appointment On de Booking Widget om er drukker en in vraag naar te maken",
      "look_busy_percentage_description" : "Hide het number of beschikbare tijdsperiodes Via x%",
      "maximum_bookings_per_slot_tooltip_personal" : "Beperk het aantal afspraken dat kan worden Scheduled voor dezelfde Time Window",
      "enable_recurring_title" : "Enable Conferencing",
      "enable_recurring_desc" : "<b>Vergaderingen met een Recurring</b> On automatisch de Trailing Settings Disable , omdat ze niet naast elkaar kunnen bestaan:",
      "date_specific_hours" : "every <b>datumspecifieke uren</b> worden Deleted.",
      "multiple_team_members" : "<b>Group Members</b> worden Unsubscribed — Members één Group kan in deze kalender overblijven.",
      "partial_payments" : "<b>Betalingen Incomplete</b> worden Disabled en het Full bedrag wordt geïnd.",
      "select_team_member_to_keep" : "Select een Group Members to Keep in deze kalender:",
      "select_team_member" : "Group Select",
      "partial_payments_disabled" : "Hoe zou You Like het Full bedrag voor Incomplete Recurring kunnen Disabled ?",
      "enable_date_specific_hours" : "Date specifieke uren Enable",
      "enable_date_specific_hours_desc" : "On <b>datumspecifieke uren</b> te draaien, wordt automatisch de Trailing Setting Disable , omdat ze niet naast elkaar kunnen bestaan:",
      "recurring_meetings_disabled" : "<b>Terugkerende vergaderingen worden uitgeschakeld</b>, {contactsLabel} kan alleen afzonderlijke afspraken boeken op basis van de beschikbare datums die u hebt ingesteld.",
      "payment_preference" : "Payment Preference:",
      "team_members_in_this_calendar" : "Group in deze kalender",
      "other_team_members" : "Other Group Members (niet toegevoegd aan deze kalender)",
      "select_team_member_tooltip" : "Select de Group die deze Conferencing zouden nemen",
      "meeting_duration_tooltip" : "This Fixed de Length of je Conferencing, bepaalt hoe lang het zal last",
      "date_specific_hours_tooltip" : "Modify je schedule voor specifieke data. Monthly Weekly hour overschrijven Via Availability Of onbeschikbaarheid voor Selected datums",
      "recurring_meeting_tooltip" : "Meerdere times per Week Enable naar Repeat",
      "repeat_frequency_tooltip" : "Select de Frequency of deze Recurring Event",
      "time_to_repeat_tooltip" : "Collection van het Total number of Repeats",
      "slots_unavailable_tooltip" : "Select wat er moet gebeuren If een Of meer Date periodes in een Recurring boeking zijn al geboekt",
      "skip_booking_tooltip" : "Alleen de beschikbare tijdsperiodes worden geboekt. Alle niet-beschikbare datums in de Recurring serie worden Skipped",
      "force_book" : "Boeken forceren",
      "force_booking_tooltip" : "every tijdsperiode wordt geboekt, Even If There is een Conflict. Gebruik met Caution om Double bookings te voorkomen",
      "book_next_available_tooltip" : "If een Selected slot niet beschikbaar is, De Next beschikbare slot Book is On (Next Recurring schedule If )",
      "slot_interval_tooltip" : "Collection de kloof tussen de times of achtereenvolgende beschikbare tijdsperiodes. Voor Model, If uw Conferencing Duration 30 minuten is en You Collection de Seconds tot 60 minuten, kan een Operator Book om AM, Then 10:00 AM, On . Even every Conferencing slechts 30 minuten duurt",
      "minimum_scheduling_notice_tooltip" : "Required Operator om vergaderingen minstens zoveel Date in tevoren Book",
      "date_range_preferences_tooltip" : "Collection hoe ver in de toekomst boekingen kunnen worden gemaakt From Today's Date",
      "maximum_bookings_per_slot_preferences_tooltip" : "Beperk het aantal afspraken dat kan worden Scheduled voor dezelfde Time Window",
      "maximum_bookings_per_slot_per_user_preferences_tooltip" : "Beperk het aantal vergaderingen dat kan worden Scheduled voor dezelfde Time Window (per Operator)",
      "pre_buffer_time_tooltip" : "Date to Enable Voor every Conferencing",
      "post_buffer_time_tooltip" : "Date to block After every Conferencing, Enable voor extra Date to wrap up",
      "seats_per_class_tooltip" : "Collection van de Max number of Members kan deze Class worden Book . Zodra every Seats is gevuld, is de Time Window niet meer beschikbaar om te boeken",
      "maximum_bookings_per_slot_per_user_tooltip" : "Beperk het aantal vergaderingen dat kan worden Scheduled voor dezelfde Time Window (per Operator)",
      "repeat_frequency" : "Repeat Frequency",
      "slot_interval" : "Seconds slot",
      "skip_booking_helper_text" : "Alleen de beschikbare tijdsperiodes worden geboekt. Alle niet-beschikbare datums in de Recurring serie worden Skipped",
      "force_book_helper_text" : "every tijdsperiode wordt geboekt, Even If There is een Conflict. Gebruik met Caution om Double bookings te voorkomen",
      "book_next_available_helper_text" : "If een Selected slot niet beschikbaar is, On de Next schedule slot Book (Monday Recurring Next ) .",
      "bulk_edit" : "Bulk bewerken",
      "select_users" : "Gebruikers selecteren",
      "select_all" : "Alles selecteren",
      "times_to_repeat_tooltip" : "Het totale aantal herhalingen instellen"
    },
    "forms_payment" : {
      "forms" : "Formulieren",
      "forms_sub" : "Post Collection Form Settings.",
      "select_form" : "Form Select",
      "enable_same_user_assignment" : "Friends toewijzen aan hun respectieve kalender Group Members every Date an Appointment is geboekt",
      "sticky_contacts" : "Sticky Fields Friends invullen",
      "confirmation_page" : "Page",
      "default" : "Standaard",
      "redirect_url" : "Omleidings-URL",
      "thank_you" : "You",
      "enter_url" : "Voer de URL in",
      "amount_tab_hidden_label" : "Tijdelijke aanduiding voor tabblad Bedrag",
      "percentage_tab_hidden_label" : "Tijdelijke aanduiding voor tabblad Percentage",
      "pixel_id" : "Meta Pixel-Id (Optional)",
      "auto_confirm" : "new kalenders automatisch bevestigen",
      "configure_payment" : "Options Configure",
      "accept_payments" : "Betalingen accepteren",
      "test" : "Test",
      "live" : "Live",
      "enable_guests" : "Gasten Add",
      "add_guest_tooltip" : "Add Guest gaat uw Guest Enable om meerdere deelnemers aan dezelfde Appointment Add",
      "add_guest_custom_form_tooltip" : "Door deze optie in te schakelen, wordt een door het systeem gegenereerde Email Upload naar gasten met een Link naar het Custom Form zodra hun Appointment Confirmed is. Om Duplicate Gmail te voorkomen, moet je ervoor zorgen dat er niet al een aparte Email is Configure voor gasten. (Verify dit in het tabblad Reminder > Confirmation Alert)",
      "add_guest_same_form_check" : "Upload dezelfde Form om Details te verzamelen Via e-mail aan every gasten",
      "payment_tooltip" : "Betaling zou alleen in rekening worden gebracht voor het PRIMARY Guest en niet voor de gasten.",
      "default_form" : "Default (Voornaam, last naam, Email, Phone, Notities)",
      "select_form_tooltip" : "If ik Like om meer Details te verzamelen dan de Default voornaam, last naam, Email en Phone From die On kalender Book , een Custom Form Create in Sites > Formulieren > Builder Then Select the Form Via the Dropdown below.",
      "confirmation_page_tooltip" : "Zodra iemand een boeking heeft gemaakt, kunt You On Custom Message Select , Show of doorverwijzen naar een Page of uw keuze ( Default ).",
      "add_guest_collect_email" : "Naam en Email",
      "add_guest_count_only" : "Alleen Count",
      "custom_email_notification" : "Custom Upload to Form",
      "consent_label" : "Selectievakje Toestemming",
      "consent_input_placeholder" : "Add Consent",
      "same_user_assignment_tooltip" : "Om deze Setting in Enable , moet de Form eerst On de Widget zijn. Reschedule de Widget naar Status van de Form om deze Setting als eerste te trigger .",
      "consent_tooltip" : "Schakel deze optie in om goedkeuring van {contactsLabel} te verkrijgen wanneer ze hun telefoonnummer opgeven tijdens het boekingsproces van een afspraak.",
      "stripe_error" : "Tot twee cijfers achter de komma (Model: 25.99)",
      "auto_confirm_service" : "Auto-bevestigen new Appointment",
      "service_form_message" : "If een Contact meerdere Services boekt, ziet deze alleen de Default in het servicemenu",
      "deposit_amount_error" : "Het aanbetalingsbedrag moet lager zijn dan het Total .",
      "deposit_percentage_error" : "Het Percentage moet minder dan 100% zijn.",
      "partial_payment_tooltip" : "Incomplete betalingen Enable om de aanbetaling te innen From Customers tijdens de Appointment booking Workflow",
      "partial_payment_enable_error" : "Het ingevoerde Total moet groter zijn dan 0 om Incomplete betalingen Enable .",
      "payment_disable_text_integration" : "Integreer een Provider voor betalingen onder Betalingen > Integraties om betalingen te accepteren",
      "payment_disable_text_recurring" : "De betalingsoptie Accepteren is niet beschikbaar voor Recurring -vergaderingen. Betalingen Disable naar Enable .",
      "date_and_time_selector" : "Date en Date selecteren",
      "form_selector" : "Formulier",
      "order_step" : "Stap",
      "widget_order_label" : "Widget Sort",
      "widget_order_tool_tip" : "Reschedule de ' Date & Date Selector' en ' Form' Sort On de Calendar Widget opnieuw in. Drag en bestel per uw Preference opnieuw.",
      "widget_re_order_tooltip" : "De volgorde wijzigen is alleen beschikbaar met de Neo Widget -stijl. Schakel over naar Neo om de volgorde opnieuw in Enable .",
      "widget_re_order_disabled_tooltip" : "Om de volgorde van de widgets te wijzigen, schakelt u \"Nieuwe afspraakvoorkeur (altijd boeken met de toegewezen gebruiker van {contactLabel})\" uit in het onderdeel Bijeenkomstinfo > Groepleden > Geavanceerde instellingen.",
      "payment_description_error" : "Max Character SLOTMAX of 1000 bereikt",
      "widget_multiple_location_disabled_tooltip" : "De Classic Widget ondersteunt geen Address Conferencing . Extract elk aanvullend Address om de Classic Widgette gebruiken",
      "recurring_payment_label" : "Appointment Recurring",
      "enable_payments_for_guests" : "Betalingen voor gasten Enable",
      "guest_payment_description" : "Aangezien You de optie \" Gasten Add \" hebt Enabled , kunt You ook de charge per Guest Select When of .",
      "charge_per_attendee" : "charge per Guest",
      "charge_per_attendee_description" : "When het Total number Via tijdens het boeken, wordt het totale of Multiply .",
      "click_confirm_description" : "Klik op Opslaan om deze wijzigingen toe te passen.",
      "multiply_amount_guests" : "Betaling innen voor every deelnemers",
      "multiply_amount_guests_description" : "When Enabled, wordt het te innen bedrag tijdens het boeken vermenigvuldigd met het number Total , inclusief gasten",
      "first_appointment_only" : "charge voor de eerste Appointment",
      "all_appointments" : "charge for every Appointment",
      "no_payment_provider_connected" : "Geen Provider verbonden",
      "no_default_payment_provider" : "Geen Provider verbonden",
      "provider_not_supported" : "Provider voor Default betaling wordt niet ondersteund",
      "manage_payment_provider" : "Manage Payment Providers",
      "supported_providers" : "Ondersteunde providers",
      "paypal_razorpay_helper_text" : "Payments will be processed through Razorpay only, as PayPal isn’t supported with custom providers",
      "rearrange_widget_order" : "Widget Sort Reschedule",
      "change_form_order" : "Dynamic the Form naar de tweede Step in de Widget Sort and Trailing Setting:",
      "change_form_order_desc" : "<b>Voorkeur voor nieuwe afspraak (altijd boeken met de toegewezen gebruiker van {contactLabel})</b> wordt uitgeschakeld. Dit betekent dat afspraken kunnen worden geboekt met elk beschikbaar groepslid, in plaats van beperkt te zijn tot de toegewezen gebruiker van de {contactLabel}.",
      "enable_mandatory_guest" : "Create het toevoegen van ten minste één Guest Required. Guest Fields is vooraf geopend en moet worden ingevuld voor een boeking.",
      "enable_mandatory_guest_count" : "Neem Required Guest Count On de Booking Widget",
      "require_guest_for_booking" : "Required -gasten voor boeking",
      "sticky_contacts_tooltip" : "Vooraf invullen velden voor bekende {contactsLabel}.",
      "auto_confirm_tooltip" : "Automatisch Watermark new meetings as Confirmed zonder Manual Approval. every boeking If Disable en You Voor it's Scheduled",
      "confirm_tooltip" : "Zodra iemand een boeking heeft gemaakt, kunt You deze On dezelfde Page Select , Show of doorverwijzen naar een Page of uw keuze ( Custom DefaultURL",
      "facebook_pixel_id_tooltip" : "",
      "accept_payments_tooltip" : "Betalingen Collection tijdens boekingen Enable",
      "total_amount_tooltip" : "The Total charge voor de Conferencing Collection",
      "deposit_amount_tooltip" : "Bedrag te innen tijdens het boeken als aanbetaling",
      "multiply_amount_guests_all_guests" : "Betaling innen voor every deelnemers, inclusief gasten",
      "multiply_amount_guests_all_guests_tooltip" : "When Enabled, wordt het te innen bedrag tijdens het boeken vermenigvuldigd met het number Total , inclusief gasten",
      "payment_description" : "Beschrijving betaling",
      "payment_description_tooltip" : "Optioneel alle nuttige Details Add About de betaling",
      "test_mode_warning" : "Dynamic Test– er wordt geen echte Sales verwerkt.",
      "pixel_id_tooltip" : "Upload Booking Widget Activity Like , clicks, and submissions to Meta Via je PixelId",
      "forms_description" : "Configure de Fields en Flow of je boeking Form",
      "payment_mode" : "Betaalmethodes",
      "payment_mode_tooltip" : "Schakel tussen Test Mode en Live modus voor betalingen. in Test Mode worden geen echte billing uitgevoerd — gebruik het om de boekings- en Workflow te simuleren. Schakel over naar de Live modus om daadwerkelijke betalingen te accepteren From Customers.",
      "enable_coupon" : "Kortingscodes inschakelen",
      "enable_coupon_tooltip" : "Sta klanten toe Kortingscodes toe te passen tijdens het boeken. Om ervoor te zorgen dat ze werken, maakt u eerst geldige Kortingscodes aan onder Betalingen > Kortingscodes."
    },
    "notifications" : {
      "notifications" : "Reminder en aanvullende Options",
      "notifications_sub" : "Alert en aanvullende Options Configure",
      "edit" : "Bewerken",
      "created_on" : "Gemaakt op",
      "updated_on" : "Bijgewerkt op",
      "delivered" : "Geleverd",
      "not_available" : "N.v.t.",
      "select_notification_type" : "of Type Select",
      "notification_person" : "Wie moet deze Alert Inherit ?",
      "contact" : "{contactLabel}",
      "guest" : "Gast",
      "assigned_user" : "Toegewezen Operator",
      "emails" : "Gmail",
      "alert_email_address" : "Email address Alert",
      "ack_email" : "E - Email",
      "send_google_invites" : "Google Agenda Enable om Upload uitnodiging of update Gmail voor deelnemers.",
      "send_google_outlook_invites" : "Inschakelen Google / Outlook / iCloud Calendar om uitnodiging & Vernieuwen e-mails naar deelnemers te Uploaden.",
      "assign_user_to_contact" : "Wijs {contactsLabel} toe aan hun respectievelijke agendagroepleden elke keer wanneer een afspraak wordt geboekt",
      "skip_assigning_user_to_contact" : "Het toewijzen van {contactLabel} overslaan als de {contactLabel} al een toegewezen gebruiker heeft",
      "assigned_staff" : "Toegewezen medewerkers",
      "additional_emails" : "Aanvullende Gmail",
      "assign_user_to_staff" : "Wijs {contactsLabel} toe aan hun respectievelijke servicemedewerkers telkens wanneer een afspraak wordt geboekt",
      "allow_cancellation" : " Enable of Conferencing",
      "allow_reschedule" : "Enable of Conferencing In",
      "allow_cancellation_tooltip" : "When Enabled, wordt een Link toegevoegd aan de aanvullende Section en opgenomen in de kalenderuitnodiging. Deze Link wordt Expired zoals geconfigureerd Voor de Conferencing start Date, waardoor wordt voorkomen dat de Booker From de Conferencing kan annuleren.",
      "allow_reschedule_tooltip" : " When Enabled, wordt een Link voor een nieuwe afspraak toegevoegd aan de aanvullende Section en in de kalenderuitnodiging opgenomen. Deze Link Expired zoals geconfigureerd Voor de Conferencing start Date, waardoor de Booker From de Conferencing niet kan verplaatsen.",
      "cancellation_link_expiry" : "De Link Expired",
      "reschedule_link_expiry" : "De Link zal Expired",
      "before_meeting" : "Voor de Conferencing",
      "cancellation_and_reschedule_policy" : "Beleid voor annuleren en Reschedule :",
      "meeting_invite_notes" : "Notities Conferencing",
      "meeting_invite_notes_tooltip" : "Notities Add die zullen verschijnen in de kalenderuitnodiging sent naar Customers. in notities Description Sync met Third Party Calendars"
    },
    "connections" : {
      "connections_heading" : "Third Party Calendars Sync",
      "connections_sub" : "Sync with Third Party Calendars occurrences",
      "link_to_calendar" : "Link naar kalender",
      "sync_option" : "Sync optie",
      "execute_automation" : "Automatisering uitvoeren",
      "fire_workflow" : "Activeer workflowtriggers voor gebeurtenissen die geboekt zijn via Sync in twee richtingen",
      "reserve_with_google" : "Book bij Google [ Te beëindigen]",
      "reserve_with_google_setup" : "Instructies voor Config View",
      "reserve_with_google_configure" : "Configureren",
      "change" : "Wijzigen",
      "rwg_deprecation_notice" : "Google heeft <strong>Book with Google (RwG)</strong>, ook bekend als <strong>Local Services Advertisements</strong>, verouderd. new verbindingen worden niet meer ondersteund. Gebruik in Google plaats <strong>Google daarvan Organische boekingen</strong> om boekingen Received Continue Via",
      "rwg_category" : "Categorie",
      "rwg_service_type" : "Service",
      "connect_lsa" : "Maak verbinding met uw lokale Ad Account voor Services",
      "reserve_error" : "now Book with Google wordt alleen ondersteund voor 'Home Services', 'Onroerend goed', 'Legal Services' (lokale serviceproviders) Business in de VS.",
      "one_way" : "Enkele reis",
      "two_way" : "Two-way",
      "smart" : "Slim",
      "confirm_remove" : "Weet je zeker dat je Google Agenda wilt Extract ?",
      "read_only_access" : "You hebt geen Access tot deze kalender. Select een andere kalender.",
      "reserve_with_google_desc" : "Deze kalenderservice wordt opgenomen in Book met alleen Google On succesvolle Integration.",
      "check_integration" : "Check Mark Status Integration",
      "setup_external" : "Config Your Third Party Calendars",
      "reserve_price_decimal_error" : "Price wordt niet ondersteund",
      "reserve_price_max_error" : "Ondersteunde Price minder dan 1000",
      "link_to_calendar_tooltip" : "Select de kalender waarmee You deze kalender wilt Sync",
      "one_way_sync" : "Eenrichtingsverkeer",
      "default_one_way" : "Standaard Sync (eenrichtingssynchronisatie)",
      "one_way_sync_desc" : "Gebeurtenissen uit de gekoppelde agenda worden gesynchroniseerd als geblokkeerde tijdsperiodes en er worden geen contacten gemaakt voor de gasten.",
      "two_way_sync" : "Sync in twee richtingen",
      "two_way_sync_desc" : "Contactpersonen worden gemaakt voor gasten die te vinden zijn in gekoppelde agenda-gebeurtenissen en deze gebeurtenissen worden omgezet in systeemafspraken.",
      "smart_sync" : "Slimme Sync",
      "smart_sync_desc" : "Gebeurtenissen uit de gekoppelde agenda worden gesynchroniseerd als afspraken voor bestaande contactpersonen. Als er geen contactpersoon bestaat, worden ze gesynchroniseerd als geblokkeerde slots zonder dat er een nieuwe contactpersoon wordt aangemaakt.",
      "sync_option_tooltip" : "Selecteer hoe gevallen uit je externe agenda worden gesynchroniseerd met deze agenda. U kunt hier alleen beschikbaarheid blokkeren of ook {contactsLabel} en afspraken maken/beheren - op basis van de synchronisatiemodus die u selecteert",
      "one_way_sync_tooltip" : "Blocks Date Slots Via import appointment occurrencescars From your Third Party Calendars",
      "two_way_sync_tooltip" : "Importeert vergaderingen en maakt {contactsLabel} en afspraken in het systeem. Wijzigingen die hier worden aangebracht, worden weergegeven in de externe kalender",
      "smart_sync_tooltip" : "Importeert alleen bijeenkomsten en maakt afspraken als de bijeenkomst is gemaakt door een bekende {contactLabel}",
      "default_sync" : "Standaard",
      "default_sync_desc" : "Synchroniseert gebeurtenissen uit uw externe agenda met deze agenda",
      "advanced_sync" : "Geavanceerd",
      "advanced_sync_desc" : "Synchroniseert gebeurtenissen uit uw externe agenda naar deze agenda en maakt contacten en afspraken aan in het systeem",
      "assign_contact_to" : "Contactpersoon toewijzen aan",
      "select_calendar" : "Agenda selecteren",
      "sync_preferences" : "Voorkeuren voor sync",
      "sync_preferences_desc" : "Hoe wilt u uw gekoppelde agenda-gebeurtenissen synchroniseren?",
      "recommended" : "Aanbevolen",
      "execute_automation_desc" : "Automatisering uitvoeren wanneer een bijeenkomst wordt gemaakt in deze agenda",
      "save" : "Wijzigingen opslaan",
      "cancel" : "Annuleren"
    },
    "extras" : {
      "extras" : "Aanpassingen",
      "extras_sub" : "Collection Widget style en Other Settings.",
      "calendar_widget_style" : "Stijl Widget",
      "neo" : "Nieuw",
      "classic" : "Klassiek",
      "insert_custom_code" : "Aangepaste code invoegen",
      "show_seats_per_slot" : "Show per slot",
      "allow_reschedule_meeting" : "Enable",
      "allow_cancelling_meeting" : "Enable Cancel Conferencing",
      "additional_notes" : "Aanvullende opmerkingen",
      "cancellation_and_reschedule" : "Annulering en Reschedule:",
      "allow_staff" : "Selectie van personeel tijdens boeking Enable",
      "code_block_tooltip" : "In het HTML blok kunnen scripts van derden krachtige functionaliteit Offer , maar brengen ook risico's met zich mee op het gebied van privacy, beveiliging, prestaties en Page . Daarom raden wij You aan om de Content of deze Code Voor Saving naar de kalender Review .",
      "calendar_image" : "Omslagafbeelding kalender",
      "remove_image" : "Extract Image",
      "calendar_image_info" : "De geüploade Image is zichtbaar in de Group View voor Neo Template en wordt niet weergegeven On de Individual kalender Link",
      "get_image_from_unsplash" : "Verbeter je afbeeldingen met",
      "unsplash" : "Unsplash",
      "service_additional_preferences" : "Aanvullende Settings Configure",
      "service_image" : "Omslagafbeelding service",
      "service_image_description" : "Select een Image van Showed On het menu Services voor deze service",
      "allow_reschedule_appointment" : "Enable",
      "allow_cancelling_appointment" : "Appointment annuleren Enable",
      "custom_code_placeholder" : "feedback here op Custom Code",
      "calendar_widget_style_desc" : "Select tussen onze Classic Van de gestroomlijnde Neo Widget",
      "seats_per_slot" : "Zetels per tijdsperiode",
      "show_staff_selection" : "Medewerkers selecteren",
      "seats_per_slot_desc" : " Schakel Booker in om het number of beschikbare Seats per Time Window te View On de Calendar Widget.",
      "show_staff_selection_desc" : "Enable naar Select a staff Members rechtstreeks From the Calendar Widget tijdens Appointment Booker . Werkt alleen met Neo Widget",
      "widget_re_order_tooltip" : "De stijl van de Classic Widget heeft Widget Sort Dynamic niet Enable . Zorg ervoor dat Date Date Selector de eerste is en de Form de tweede. Voor het selecteren van de stijl Classic .",
      "show_staff_selection_desc_service" : "Enable naar Select a staff Members rechtstreeks From the Calendar Widget tijdens Appointment Booker .",
      "switch_to_classic_widget" : "Overschakelen naar Classic Widget",
      "switch_to_classic_widget_desc" : "Dynamic to the <b>Classic Widget</b> schakelt de Trailing Settings automatisch in , omdat ze niet naast elkaar kunnen bestaan:",
      "form_first_disabled" : "<b>De Form wordt verplaatst naar de tweede Step</b> in de Widget Sort.",
      "appointment_preference_disabled" : "<b>Voorkeur voor nieuwe afspraak (altijd boeken met de toegewezen gebruiker van {contactLabel})</b> wordt uitgeschakeld. Dit betekent dat afspraken kunnen worden geboekt met elk beschikbaar groepslid, in plaats van beperkt te zijn tot de toegewezen gebruiker van de {contactLabel}.",
      "multiple_location_disabled" : "<b>Meerdere Conferencing Address</b> worden Deleted en alleen de <b>eerst toegevoegde Location</b> blijft behouden.",
      "insert_custom_code_tooltip" : "Widget -styling Customize Via uw eigen CSS Code",
      "classic_tooltip_disabled" : "De klassieke widget wordt niet ondersteund voor lesagenda's",
      "show_staff_selection_disabled_tooltip" : "Medewerkersselectie wordt alleen ondersteund voor de neo-widget"
    },
    "roomsAndEquipments" : {
      "title" : "Select Room and Equipment",
      "description" : "Select From a List of Room en Equipment wat er bij deze kalender wordt geboekt",
      "rooms" : "Room Select",
      "equipments" : "Equipment Select"
    }
  },
  "activity_log" : {
    "activity_log" : "Activiteitenlogboek",
    "date" : "Datum",
    "filter_by" : "Filteren op",
    "calendar_update" : "Kalenderupdate",
    "start_time_update" : "Begintijd bijwerken",
    "end_time_update" : "Eindtijd bijwerken",
    "title_update" : "Titel bijwerken",
    "notes_update" : "Notities bijwerken",
    "appointment_status_update" : "Statusupdate afspraak",
    "meeting_location_update" : "Bijeenkomst locatie bijwerken",
    "google_sync_update" : "Google Sync bijwerken",
    "outlook_sync_update" : "Outlook Sync bijwerken",
    "assigned_user_update" : "Toegewezen gebruiker bijwerken",
    "appointment_status" : "Afspraakstatus",
    "assigned_user" : "Toegewezen gebruiker",
    "uploaded_to" : "Geüpload naar",
    "cancelled" : "Geannuleerd",
    "edited" : "bewerkt",
    "other_edits" : "Andere bewerkingen",
    "view_details" : "Bekijk details",
    "all" : "Alle"
  },
  "appointment_list" : {
    "group_all" : "ALLE",
    "group_primary" : "PRIMAIRE",
    "group_user" : "GEBRUIKERS",
    "group_team" : "GROEPEN",
    "group_calendar" : "KALENDERS",
    "all_appointments" : "Alle afspraken",
    "my_calendar" : "Mijn kalender",
    "status_all" : "Alle",
    "status_confirmed" : "Bevestigde",
    "status_new" : "Nieuw (actie vereist)",
    "status_show" : "Aanwezigen",
    "status_no_show" : "Afwezigen",
    "status_cancelled" : "Annulaties",
    "status_invalid" : "Ongeldig",
    "filter_date_added_desc" : "Datum toegevoegd (desc)",
    "filter_start_added_desc" : "Begindatum (desc)",
    "filter_start_added_asc" : "Begindatum oplopend vanaf vandaag",
    "button_new_appointment" : "Nieuwe afspraak",
    "name" : "Naam",
    "title" : "Titel",
    "requested_time" : "Verzochte tijd",
    "date_added" : "Datum toegevoegd",
    "calendar" : "Kalender",
    "appointment_owner" : "Eigenaar afspraak",
    "notes" : "Notities",
    "status" : "Status",
    "action_view_detail" : "Details bekijken",
    "action_view_consent" : "Toestemming bekijken",
    "action_view_notes" : "Notities bekijken",
    "action_edit" : "Bewerken",
    "action_delete" : "Verwijderen",
    "action_reschedule" : "Opnieuw inplannen",
    "page_previous" : "Vorige",
    "page_next" : "Volgende",
    "appointment_notes" : "Notities afspraak",
    "close" : "Sluiten",
    "confirm_delete_header" : "Afspraak verwijderen",
    "confirm_delete_message" : "Weet je zeker dat je deze afspraak wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt!",
    "confirm_delete_button" : "Verwijderen",
    "confirm_update_header" : "Afspraakstatus bijwerken",
    "confirm_update_confirmed_message" : "Weet je zeker dat je deze afspraak als geverifieerd wilt markeren?",
    "confirm_update_invalid_message" : "Weet je zeker dat je deze afspraak als vervallen wilt markeren?",
    "confirm_update_showed_message" : "Weet je zeker dat je deze afspraak als aanwezig wilt markeren?",
    "confirm_update_noshow_message" : "Weet je zeker dat je deze afspraak als afwezig wilt markeren?",
    "confirm_update_cancelled_message" : "Weet je zeker dat je deze afspraak als geannuleerd wilt markeren?",
    "confirm_update_button" : "Bijwerken",
    "empty_state_title" : "Geen afspraken gevonden",
    "empty_state_description" : "Geen afspraken gevonden",
    "disable_menu_warning" : "Momenteel heb je geen toestemming om de details van de afspraak te bekijken of te bewerken, omdat de bijbehorende contactpersoon niet aan je is toegewezen. Neem contact op met je admin voor verdere hulp.",
    "no_contact_warning" : "Je hebt momenteel geen toegang tot contactgegevens. Dit kan komen doordat het contact niet aan je is toegewezen. Neem contact op met je admin voor hulp.",
    "consent_label" : "Toestemming",
    "ip_address" : "IP",
    "youre_viewing_in" : "Wordt momenteel bekeken in",
    "appointment_delete_msg" : "<b>Opgelet:</b> De hier verwijderde afspraak, wordt niet verwijderd uit Calendly.",
    "rescheduled" : "Opnieuw ingepland"
  },
  "add_guest" : {
    "guest_label" : "Gast(en)",
    "search_placeholder" : "From Search",
    "add_new" : "Add new",
    "save" : "Archive",
    "close" : "Close",
    "name" : "Naam",
    "phone" : "Telefoon",
    "email" : "E-mail",
    "guest_label_count" : "Guest(s )",
    "guest_count_error" : "Count van Guest moeten tussen 1 en 100 . liggen"
  },
  "languages" : {
    "danish" : "Danish",
    "dutch" : "Dutch",
    "english" : "English",
    "finnish" : "Finnish",
    "french" : "French",
    "french_canada" : "French (Canada)",
    "german" : "German",
    "hungarian" : "Hungarian",
    "italian" : "Italian",
    "norwegian" : "Norwegian",
    "polish" : "Polish",
    "portuguese_brazil" : "Portuguese (Brazil)",
    "portuguese_portugal" : "Portuguese (Portugal)",
    "spanish" : "Spanish",
    "swedish" : "Swedish",
    "turkish" : "Turkish"
  },
  "service_menu_advanced" : {
    "new_service_menu_details_header" : "Details servicemenu",
    "select_groups_header" : "ServicesSelect",
    "arrange_groups_header" : "Je Services Configure",
    "new_service_menu" : "new Menu",
    "service_menu_sub_title" : "Create een Custom servicemenu aan voor uw Customers in slechts een paar klikken",
    "quick_tip" : "Je kunt Add Group naar het servicemenu",
    "service_menu_name" : "Naam servicemenu",
    "service_menu_description" : "Beschrijving",
    "service_menu_slug" : "Service URL",
    "select_groups_calendars" : "Select Group en kalenders",
    "select_groups_calendars_desc" : "Services Add aan je servicemenu",
    "select_all" : "Select every",
    "arrange_groups" : "of Sort Configure",
    "arrange_groups_desc" : "Bepaal de Pipeline of On het servicemenu",
    "arrange_services_quicktip" : "Om Calendars Reschedule binnen Group, gaat u naar Group > Options > Calendars Reschedule .",
    "enable_add_guest_desc" : "Customers Enable op extra gasten Add When het maken van een boeking.",
    "enable_multiple_service_desc" : "Customers Enable om meerdere Services in a Individual te Book .",
    "enable_staff_selection_desc" : "Enable naar Select personeel Members When het maken van een boeking.",
    "enable_add_guest" : "Add Enable",
    "enable_multiple_service" : "Meerdere services selecteren Enable",
    "enable_staff_selection" : "Medewerkersselectie Enable",
    "additional_options" : "Aanvullende Options",
    "code_block_tooltip" : "In het HTML blok kunnen scripts van derden krachtige functionaliteit Offer , maar brengen ook risico's met zich mee op het gebied van privacy, beveiliging, prestaties en Page . Daarom raden wij You aan de Content of deze Code Voor Saving in het servicemenu Review .",
    "custom_code_placeholder" : "feedback here op Custom Code",
    "insert_custom_code" : "Aangepaste code invoegen",
    "no_service" : "Geen service gevonden",
    "no_service_desc" : " Geen Services found. Services Create en ze Add aan Group to Create menu.",
    "learn_more" : "Meer informatie",
    "no_service_selected" : "Selected service",
    "create_service_calendars" : "Serviceagenda's Create",
    "alert_description" : " in het servicemenu Sort to Create , You moet servicekalenders Create en Add aan Group",
    "dont_show_again" : "Show dit niet meer",
    "service_name_required" : "Service Menu Name is Required",
    "slug_already_taken" : "Deze Slug is al gebruikt",
    "slug_required" : "Slug is Required",
    "please_enter_name" : "Voer een naam in",
    "service_name_placeholder" : "PRIMARY Menu",
    "service_slug_placeholder" : "hoofdmenu",
    "form_label" : "Formulier",
    "consent_label" : "Selectievakje Toestemming",
    "consent_input_placeholder" : "Add Consent",
    "consent_tooltip" : "Schakel deze optie in om goedkeuring van {contactsLabel} te verkrijgen wanneer ze hun telefoonnummer opgeven tijdens het boekingsproces van een afspraak.",
    "back_message" : "Back naar List",
    "saving_changes" : "Just not minute — Saving de laatste Dynamic...",
    "payment_provider_warning" : "Let op! Service menu's ondersteunen momenteel alleen betalingen via Stripe en Authorize.net. Aangezien uw standaardprovider verschilt, wordt het innen van betalingen voor geselecteerde agenda's waarvoor betalingen zijn ingeschakeld, overgeslagen.",
    "aria" : {
      "consent_form_toggle" : "Schakelaar toestemmingsformulier",
      "enable_add_guest_toggle" : "Schakelaar gast toevoegen inschakelen",
      "enable_multiple_services_toggle" : "Schakelaar meerdere services inschakelen",
      "enable_staff_selection_toggle" : "Schakelaar selectie van medewerkers inschakelen"
    }
  },
  "widget_configuration" : {
    "customise_calendar_widget" : "Customize Calendar Widget",
    "works_with_neo_widget" : "Werkt alleen met Neo Widget",
    "customise_widget_desc" : "Customize Widget Appearance: PRIMARY Color, Background Color and Button Body.",
    "learn_more" : "Meer informatie",
    "primary_settings" : "PRIMARY",
    "primary_settings_desc" : "Configure the PRIMARY Color, Background Color and Other Widget Settings to Customize Your Calendar Widget",
    "primary_color" : "PRIMARY",
    "primary_color_desc" : "Definieer de Color voor Button, datums, Date periodes en activities",
    "background_color" : "Background Color",
    "background_color_desc" : "Collection die dient Background achtergrond voor Color date-uur selector als Form.",
    "button_text" : "Body Button",
    "button_text_desc" : "Customize the Body Recommended On de Button When",
    "calendar_title" : "Titel kalender",
    "calendar_title_desc" : "De naam van je kalender",
    "calendar_description" : "Beschrijving kalender",
    "calendar_description_desc" : "De ingevoerde Description",
    "calendar_details" : "Details",
    "calendar_details_desc" : "Bevat Details zoals Duration, Date & Date, Recurring Details en tijdzone",
    "reset_to_default" : "Reset naar Default",
    "preview_widget" : "WidgetPreview",
    "calendar_title_tooltip" : "Collection If de kalendernaam en Group (If van toepassing) moeten zichtbaar zijn On de Booking Widget.",
    "calendar_description_tooltip" : "Collection If the Calendar Description moet zichtbaar zijn On the Booking Widget.",
    "calendar_details_tooltip" : "Collection If Key afspraken Details zoals Conferencing Duration, Selected Date & Date en herhalingsinfo (If van toepassing) moeten zichtbaar zijn On de Booking Widget.",
    "insert_custom_code_tooltip" : "Customize Widget -styling Via je eigen CSS Code.",
    "staff_selection_tooltip" : "Enable naar Select a staff Members rechtstreeks From the Calendar Widget tijdens Appointment Booker . Werkt alleen met Neo Widget."
  },
  "eventNotification" : {
    "customFields" : "Custom Fields",
    "customValues" : "Aangepaste waarden",
    "guest" : "Gast",
    "assignedUser" : "Toegewezen gebruiker",
    "additionalEmails" : "Aanvullende e-mailadressen",
    "list" : {
      "booked" : {
        "title" : "Afspraak geboekt (status: niet bevestigd)",
        "note" : "Deze melding wordt verstuurd wanneer een nieuwe afspraak wordt gemaakt met de status Onbevestigd.",
        "subTitle" : "Meldt wanneer een afspraak is geboekt met een onbevestigde status"
      },
      "confirmation" : {
        "title" : "Afspraak geboekt (status: Bevestigd)",
        "note" : "Deze melding wordt verzonden wanneer een afspraak wordt gemaakt met, of bijgewerkt naar de status Bevestigd.",
        "subTitle" : "Meldt wanneer een afspraak is bevestigd"
      },
      "cancellation" : {
        "title" : "Annulering",
        "note" : "Deze melding wordt verzonden wanneer een afspraak wordt geannuleerd, als no-show wordt gemarkeerd of als ongeldig wordt gemarkeerd.",
        "subTitle" : "Waarschuwt wanneer een afspraak wordt geannuleerd"
      },
      "reschedule" : {
        "title" : "Opnieuw inplannen",
        "note" : "Deze Alert is sent When Appointment is opnieuw ingepland. Het wordt alleen geactiveerd If de Appointment de Status in of Confirmed heeft.",
        "subTitle" : "Meldt wanneer een afspraak wordt verplaatst"
      },
      "reminder" : {
        "title" : "Herinnering",
        "note" : "Deze Alert is sent als Reminder voor Appointment. Het wordt alleen geactiveerd If de Appointment de Status in of Confirmed heeft.",
        "subTitle" : "Stuurt een herinnering voor de afspraak"
      },
      "followup" : {
        "title" : "Vervolg",
        "note" : "Deze melding wordt na de afspraak als vervolgbericht verzonden. Dit wordt alleen geactiveerd als de afspraak de status Onbevestigd, Bevestigd of Weergegeven heeft.",
        "subTitle" : "Stuurt een vervolgbericht nadat de afspraak is voltooid"
      }
    },
    "saveToastMsg" : "Instellingen opgeslagen!",
    "saveToastMsgDesc" : "Uw wijzigingen zijn succesvol opgeslagen",
    "enableSuccess" : "Reminder Enabled!",
    "disableSuccess" : "Reminder Disabled!",
    "tooltip" : "Deze melding is uitgeschakeld. Schakel deze in om wijzigingen aan te brengen.",
    "enabled" : "Ingeschakeld",
    "disabled" : "Uitgeschakeld",
    "statusLabel" : "Statuslabels",
    "email" : {
      "channelName" : "E-mail",
      "noneTemplate" : "Geen",
      "notificationLabel" : "Wie moet deze pushmelding ontvangen?",
      "sendButtonLabel" : "Test-e-mail verzenden",
      "testEmailLabel" : "Test-e-mail",
      "testEmailPlaceholder" : "Voer het e-mailadres van de ontvanger in voor testdoeleinden",
      "body" : "E-mail tekst",
      "bodyPlaceholder" : "Typ hier uw bericht",
      "subject" : "Onderwerp",
      "subjectPlaceholder" : "Voer het onderwerp van de e-mail in",
      "templateLabel" : "E-mailsjabloon",
      "templatePlaceholder" : "Selecteer een e-mailsjabloon of begin helemaal opnieuw",
      "fromNamePlaceholder" : "Naam invoeren",
      "fromNameLabel" : "Van naam",
      "fromAddressLabel" : "From Address",
      "alertEmailAddress" : "Voer Email ID 'Via in",
      "addMore" : "Meer toevoegen",
      "afterAppointmentEnds" : "nadat de afspraak is afgelopen",
      "beforeAppointmentStarts" : "voordat de afspraak begint",
      "durationLabel" : "Wanneer wilt u de pushmelding activeren?",
      "disableEmailNotification" : "E-mailmeldingen uitschakelen",
      "enableEmailNotification" : "E-mailmeldingen inschakelen",
      "enableSuccess" : "E-mailmelding ingeschakeld!",
      "enableSuccessDesc" : "U ontvangt vanaf nu deze melding",
      "disableSuccess" : "E-mailmelding uitgeschakeld!",
      "disableSuccessDesc" : "U ontvangt deze melding niet meer",
      "reset_to_default" : "Reset naar Default",
      "testEmailSuccessTitle" : "Test-e-mail verzonden!",
      "testEmailSuccessDesc" : "De test-e-mail is verzonden naar {email}",
      "testEmailErrorTitle" : "Test-e-mail verzenden mislukt",
      "testEmailErrorDesc" : "Er is een fout opgetreden bij het verzenden van de test-e-mail. Probeer het opnieuw."
    },
    "inApp" : {
      "channelName" : "In de app",
      "title" : "Meldingsinstellingen",
      "enableInAppNotification" : "Meldingen in de app inschakelen",
      "disableInAppNotification" : "Meldingen in de app uitschakelen",
      "selectedUser" : {
        "label" : "Verzenden naar",
        "helperText" : "Deze interne melding wordt verstuurd via het web en de mobiele app",
        "placeholder" : "Selecteer gebruiker(s)"
      },
      "enableSuccess" : "In-app-meldingen ingeschakeld!",
      "enableSuccessDesc" : "U ontvangt vanaf nu deze melding",
      "disableSuccess" : "In-app-meldingen uitgeschakeld!",
      "disableSuccessDesc" : "U ontvangt deze melding niet meer"
    },
    "sms" : {
      "channelName" : "Sms",
      "noneTemplate" : "Geen",
      "notificationLabel" : "Voor wie is deze melding bedoeld?",
      "sendButtonLabel" : "Test-sms verzenden",
      "testSMSLabel" : "Test-sms (voer telefoonnummer met landcode in)",
      "testSMSPlaceholder" : "+12345678901",
      "body" : "Sms-bericht",
      "bodyPlaceholder" : "Typ hier uw sms-bericht",
      "durationLabel" : "Wanneer wilt u de pushmelding activeren?",
      "disableSMSNotification" : "Sms-meldingen uitschakelen",
      "enableSMSNotification" : "Sms-meldingen inschakelen",
      "enableSuccess" : "Sms-melding ingeschakeld!",
      "enableSuccessDesc" : "U ontvangt vanaf nu deze melding",
      "disableSuccess" : "SMS-melding uitgeschakeld!",
      "disableSuccessDesc" : "U ontvangt deze melding niet meer",
      "alertPhoneNumbers" : "Voer telefoonnummers in (met landcodes, gescheiden door komma's)",
      "alertPhoneNumbersPlaceholder" : "+12345678901, +447123456789",
      "addMore" : "Meer toevoegen",
      "afterAppointmentEnds" : "nadat de afspraak is afgelopen",
      "beforeAppointmentStarts" : "voordat de afspraak begint",
      "templateLabel" : "Sms-sjabloon",
      "templatePlaceholder" : "Selecteer sms-sjabloon...",
      "reset_to_default" : "Terugzetten naar standaard",
      "testSmsSuccessTitle" : "Test-sms verzonden!",
      "testSmsSuccessDesc" : "De test-sms is verzonden naar {phone}",
      "testSmsErrorTitle" : "Test-sms verzenden mislukt",
      "testSmsErrorDesc" : "Er is een fout opgetreden bij het verzenden van de test-sms. Probeer het opnieuw."
    },
    "whatsapp" : {
      "channelName" : "WhatsApp",
      "notificationLabel" : "Voor wie is deze melding bedoeld?",
      "sendButtonLabel" : "WhatsApp-testmelding verzenden",
      "testWhatsAppLabel" : "Test WhatsApp-melding (voer telefoonnummer met landcode in)",
      "testWhatsAppPlaceholder" : "+12345678901",
      "durationLabel" : "Wanneer wilt u de melding activeren?",
      "alertPhoneNumbers" : "Voer telefoonnummers in (met landcodes, gescheiden door komma's)",
      "alertPhoneNumbersPlaceholder" : "+12345678901, +447123456789",
      "addMore" : "Meer toevoegen",
      "afterAppointmentEnds" : "nadat de afspraak is afgelopen",
      "beforeAppointmentStarts" : "voordat de afspraak begint",
      "templateLabel" : "WhatsApp-sjabloon",
      "templatePlaceholder" : "WhatsApp-sjabloon selecteren",
      "noPreview" : "Geen sjabloon geselecteerd",
      "templateRequired" : "Sjabloon vereist",
      "testWhatsAppSuccessTitle" : "WhatsApp-testmelding verzonden!",
      "testWhatsAppSuccessDesc" : "WhatsApp-testmelding is succesvol verzonden naar {phone}",
      "testWhatsAppErrorTitle" : "Het uploaden van een WhatsApp-testmelding is mislukt",
      "testWhatsAppErrorDesc" : "Er is een fout opgetreden bij het verzenden van de WhatsApp-testmelding Probeer het opnieuw.",
      "setupTitle" : "Contacteer uw klanten via hun favoriete communicatie-app",
      "setupDescription" : "Sta uw klanten beter bij met directe ondersteuning, tijdige updates en boeiende interacties.",
      "connectWhatsApp" : "WhatsApp koppelen",
      "checkingStatus" : "WhatsApp-accountstatus controleren...",
      "checkingTemplateStatus" : "WhatsApp-sjabloonstatus controleren...",
      "statusCheckError" : "Kan de status van het WhatsApp-account niet controleren",
      "templateStatusCheckError" : "Kan de status van de WhatsApp-sjabloon niet controleren",
      "setupTemplateTitle" : "Voltooi je WhatsApp-sjabloonconfiguratie",
      "setupTemplateDescription" : "U moet WhatsApp-sjablonen configureren voor u meldingen kunt uploaden. Klik hieronder om het installatieproces te voltooien.",
      "loadTemplatesError" : "Kan WhatsApp-sjablonen niet laden",
      "templatesRefreshed" : "Sjablonen succesvol vernieuwd",
      "templatesRefreshError" : "Het vernieuwen van sjablonen is mislukt",
      "templatesResolveError" : "Fout bij het oplossen van WhatsApp-standaardsjablonen",
      "locationNotFound" : "Locatie-ID niet gevonden",
      "settingsRedirectError" : "Kan niet doorverwijzen naar WhatsApp-instellingen",
      "updateNotificationError" : "Kan WhatsApp-melding niet bijwerken",
      "notificationsEnabled" : "WhatsApp-melding ingeschakeld!",
      "notificationsDisabled" : "WhatsApp-melding uitgeschakeld!",
      "updateError" : "Fout bij het bijwerken van meldingen",
      "createNewTemplate" : "Nieuwe WhatsApp-sjabloon maken",
      "phoneValidation" : {
        "countryCodeRequired" : "Het telefoonnummer moet beginnen met een landcode (bijvoorbeeld +1, +91, +44).",
        "digitsOnly" : "Het telefoonnummer mag alleen cijfers bevatten na de landcode.",
        "tooShort" : "Telefoonnummer is te kort",
        "tooLong" : "Telefoonnummer is te lang",
        "invalid" : "Ongeldig telefoonnummer"
      },
      "errors" : {
        "templateNotFound" : "Sjabloon-ID niet gevonden in geladen opties, wissen",
        "templateNoLongerValid" : "Opgeslagen sjabloon niet langer geldig, wissen",
        "invalidTemplateSelection" : "Poging om ongeldige WhatsApp-sjabloon te selecteren",
        "fetchingTemplates" : "Fout bij het ophalen van WhatsApp-sjablonen",
        "mountingCreator" : "Fout bij het monteren van WhatsApp Template Creator",
        "fetchingAfterCreation" : "Fout bij het ophalen van WhatsApp-sjablonen na het aanmaken",
        "updateStatus" : "Fout bij het bijwerken van WhatsApp-status"
      },
      "receiverLabels" : {
        "assignedUser" : "Toegewezen gebruiker",
        "phoneNumbers" : "Aanvullende telefoonnummers"
      }
    }
  },
  "smsTemplate" : {
    "create_new_template" : "Nieuw sms-sjabloon maken",
    "create_new_template_desc" : "Maak een herbruikbaar sms-sjabloon voor uw meldingen",
    "template_name" : "Naam sjabloon",
    "template_name_placeholder" : "Voer de sjabloonnaam in",
    "message" : "Bericht",
    "message_placeholder" : "Typ hier uw sms-bericht",
    "create_template" : "Sjabloon maken",
    "name_required" : "Sjabloonnaam is vereist",
    "text_required" : "Berichttekst is vereist",
    "fetch_new_templates" : "Sjablonen vernieuwen"
  },
  "whatsappTemplate" : {
    "create_new_template" : "Nieuwe WhatsApp-sjabloon maken",
    "create_new_template_desc" : "Maak een herbruikbare WhatsApp-sjabloon voor uw meldingen",
    "template_name" : "Naam sjabloon",
    "template_name_placeholder" : "Voer de sjabloonnaam in",
    "message" : "Bericht",
    "message_placeholder" : "Typ hier uw WhatsApp-bericht",
    "create_template" : "Sjabloon maken",
    "name_required" : "Sjabloonnaam is vereist",
    "text_required" : "Berichttekst is vereist",
    "fetch_new_templates" : "Sjablonen vernieuwen"
  },
  "archivedServices" : {
    "servicesBanner" : "Een new, geüpgradede Version of Services is hier: krachtiger, flexibeler en intuïtiever. Uw serviceagenda's zijn al gemigreerd. Verken ze now in het tabblad Services .",
    "archivedServiceCalendars" : "Servicekalenders (v1)",
    "check_new_services" : "new Check Mark Services"
  },
  "tour" : {
    "hidden_test_label" : "Test",
    "calendar" : {
      "edit_calendar" : "Calendar Edit",
      "share_calendar" : "Calendar Share",
      "troubleshoot_calendar" : "Troubleshoot Calendar",
      "more_options" : "Meer Options",
      "edit_calendar_desc" : "Manage every Calendar Settings — Fixed Availability , Reminder Configure , Modify wijzigen en meer.",
      "share_calendar_desc" : "Copy en Share uw Scheduling Link zodat Booker eenvoudig kan schedule met You",
      "troubleshoot_calendar_desc" : "Ontdek waarom een tijdsperiode niet wordt weergegeven en bekijk potentieel oorzaken in het overzicht voor probleemoplossing.",
      "more_options_desc" : "Access aanvullende Settings en activities om je agenda te Manage .",
      "read_permissions" : {
        "share_description" : "Geef anderen toegang door de kalenderlink te delen of de machtigingen aan te passen.",
        "troubleshoot_description" : "Identificeer problemen zoals synchronisatiefouten of ontbrekende gebeurtenissen en los ze op voor een soepele werking."
      },
      "next" : "Volgende",
      "start_over" : "About beginnen",
      "all_set" : "every Collection!",
      "previous" : "Vorige"
    }
  },
  "emailTemplate" : {
    "select_editing_experience" : "Je bewerkingservaring Select",
    "select_editing_experience_desc" : "Select om te bouwen Via onze visuele ontwerp- Editor met slepen en neerzetten van de krachtige Code Editor",
    "design_editor" : "Design Editor",
    "design_editor_desc" : "Visueel, Drag & Drop Edit.",
    "code_editor" : "Code Editor",
    "code_editor_desc" : "Features Rich HTML Editing.",
    "text_editor" : "Editorvoor eenvoudige Code",
    "text_editor_desc" : "Simple, strakke Body zonder franjes.",
    "email_text_block" : "Email kan ook worden Created Via Body Block. ",
    "select" : "Selecteren",
    "new_template" : "new Template",
    "email_block" : "Email kan ook worden Created Via Body Block.",
    "fetch_new_templates" : "new sjablonen ophalen"
  },
  "quick_tips" : {
    "meeting_details" : {
      "include_contact_and_user_names" : "Als u zowel de naam van de contactpersoon als de naam van de gebruiker van de afspraak in de titel van de vergadering wilt opnemen, gebruikt u de volgende indeling: &#123;&#123;contact.name&#125;&#125; X &#123;&#123;appointment.user.name&#125;&#125;",
      "add_backup_meeting_url" : "Om ononderbroken toegang te garanderen, voegt u een aangepaste vergaderings-URL toe als back-upoptie voor het geval er problemen zijn met de Zoom- of Gmeet-integratie.",
      "enable_gmeet_primary" : "Als u Gmeet-functionaliteit wilt inschakelen, moet u ervoor zorgen dat de Google-agenda van het teamlid is ingesteld als primaire agenda in de instellingen."
    },
    "availability" : {
      "twenty_four_hours" : "Om de kalender 24 uur per dag beschikbaar te maken, stelt u het tijdsbereik in van 12 uur 's ochtends tot 12 uur 's ochtends.",
      "update_timezone_preferences" : "Tijdzones kunnen op elk gewenst moment worden gewijzigd onder Bedrijfsprofiel >> Voorkeuren voor tijdzones.",
      "service_calendar_slot_interval" : "Stel de beschikbaarheid van uw servicekalender in, met een standaard interval van 15 minuten tussen afspraken."
    },
    "forms" : {
      "create_custom_forms" : "Maak eenvoudig aangepaste formulieren in de sectie Marketing onder 'Formulieren' en integreer ze naadloos in kalenders voor een georganiseerde gegevensverzameling.",
      "apply_sticky_contacts" : "Wanneer u een aangepast formulier toevoegt, worden de instellingen voor vastgezette contacten die aan het formulier zijn gekoppeld automatisch toegepast.",
      "use_custom_values" : "U hebt de mogelijkheid om aangepaste waarden en velden van contactpersonen op te nemen in zowel het formulierbericht als de formulier-URL."
    },
    "notifications" : {
      "use_workflows" : "Gebruik voor geavanceerde herinneringen workflows of triggers voor geboekte afspraken."
    },
    "customizations" : {
      "update_widget_language" : "Als u de taalinstellingen van de widget wilt wijzigen, gaat u naar Instellingen >> Kalenders >> Voorkeuren >> Accountvoorkeuren."
    },
    "equipments" : {
      "room_definition" : "Een 'ruimte' kan elke locatie vertegenwoordigen waar diensten worden verleend. Dit kunnen fysieke ruimtes en/of speciale stations zijn. Bijv.: pedicurestation.",
      "equipment_definition" : "Beschouw 'uitrusting' als elk hulpmiddel of apparaat dat bedrijven gebruiken om afspraken na te komen. Dit kunnen machines, apparaten of zelfs stoelen zijn."
    }
  },
  "aria_labels" : {
    "sticky_contacts" : "Vastgezette contacten",
    "consent_form" : "Toestemmingsformulier",
    "enable_guests" : "Gasten inschakelen",
    "auto_confirm" : "Automatisch opslaan",
    "should_accept_payment" : "Moet betaling accepteren",
    "collect_deposit" : "Aanbetaling verzamelen",
    "enable_charge_guests" : "Gasten in rekening brengen inschakelen",
    "enable_coupon" : "Coupon inschakelen",
    "payment_live" : "Live uitbetaling",
    "add_availability_hour" : "Beschikbaarheidsuur toevoegen",
    "remove_availability_hour" : "Beschikbaarheidsuur verwijderen",
    "copy_availability_hour" : "Beschikbaarheidsuur kopiëren",
    "close_modal" : "Modal afsluiten",
    "add_custom_slot" : "Aangepaste tijdsperiode toevoegen",
    "remove_custom_slot" : "Aangepaste tijdsperiode verwijderen",
    "edit_custom_slot" : "Aangepaste tijdsperiode bewerken",
    "update_frequency" : "Updatefrequentie",
    "show_calendar_title" : "Kalendertitel weergeven",
    "show_calendar_description" : "Kalenderbeschrijving tonen",
    "show_calendar_details" : "Kalendergegevens weergeven",
    "allow_reschedule" : "Opnieuw inplannen toestaan",
    "allow_cancellation" : "Annuleren toestaan",
    "category_actions" : "Categorie-activiteiten"
  },
  "placeholders" : {
    "pixel_id" : "Pixel-ID",
    "select_one" : "Selecteer één optie",
    "meeting_location" : "Vergaderlocatie",
    "schedule_meeting" : "Vergadering inplannen",
    "notes" : "Notities",
    "select_users" : "Gebruikers selecteren"
  },
  "alt_text" : {
    "payment_provider" : "Betalingsaanbieder",
    "no_calendars" : "Geen kalenders",
    "date_specific_hours" : "datumspecifieke-uren",
    "custom_widget_image" : "Afbeelding aangepaste widget",
    "service_calendar" : "Servicekalender",
    "event_calendar" : "Evenementenkalender",
    "round_robin_booking" : "Round-robin-boeking",
    "class_booking" : "Boeking van klassen",
    "collective_booking" : "Gezamenlijke boeking"
  },
  "tooltips" : {
    "text_color" : "Tekstkleur",
    "background_color" : "Achtergrondkleur",
    "strikethrough" : "Doorhalen",
    "superscript" : "Superscript",
    "subscript" : "Subscript",
    "inline_code_block" : "Inline codeblok",
    "code_block" : "Codeblok",
    "block_quote" : "Blokcitaat",
    "more" : "Meer",
    "upload" : "Uploaden"
  },
  "labels" : {
    "reset_style" : "Stijl terugzetten",
    "reset_document_style" : "Documentstijl terugzetten",
    "source_code" : "Broncode",
    "success" : "Gelukt",
    "edit" : "Bewerken",
    "submit" : "Verzenden",
    "cancel" : "Annuleren",
    "payment" : "Betaling",
    "here_is_the_link" : "Hier is de link:",
    "here_is_the_embed_code" : "Hier is de insluitcode:",
    "service_calendar" : "Servicekalender",
    "collective_booking" : "Gezamenlijke boeking",
    "class_booking" : "Boeking van klassen",
    "round_robin_booking" : "Round Robin-boeking",
    "event_calendar" : "Evenementenkalender",
    "personal_booking" : "Persoonlijke boeking",
    "service_booking" : "Serviceboeking"
  },
  "validation_messages" : {
    "calendar_group_name_required" : "De naam van de kalendergroep is vereist",
    "calendar_group_description_required" : "De beschrijving van de kalendergroep is vereist",
    "slug_required" : "Slug is vereist",
    "slug_not_valid" : "Deze slug is ongeldig",
    "slug_already_taken" : "Deze slug is al in gebruik",
    "error_validating_slug" : "Fout bij het valideren van slug",
    "please_enter_name" : "Voer een naam in",
    "room_name_required" : "Naam van ruimte is vereist",
    "equipment_name_required" : "Naam van uitrusting is vereist",
    "subject_required" : "Onderwerp is vereist",
    "this_is_required" : "Dit is vereist",
    "calendar_group_slug_required" : "De naam (slug) van de kalendergroep is vereist",
    "capacity_mandatory" : "Capaciteit is vereist",
    "capacity_cannot_be_zero" : "Capaciteit kan niet nul zijn",
    "capacity_should_be_a_number" : "Capaciteit moet een getal zijn",
    "capacity_cannot_be_negative" : "Capaciteit kan niet negatief zijn",
    "capacity_should_be_a_whole_number" : "Capaciteit moet een geheel getal zijn",
    "quantity_mandatory" : "Aantal is vereist",
    "quantity_cannot_be_zero" : "Aantal kan niet nul zijn",
    "quantity_should_be_a_number" : "Aantal moet een getal zijn",
    "quantity_cannot_be_negative" : "Aantal kan niet negatief zijn",
    "quantity_should_be_a_whole_number" : "Aantal moet een geheel getal zijn",
    "quantity_cannot_be_less_than_out_of_service_equipments" : "Aantal mag niet minder zijn dan het aantal buiten gebruik zijnde apparatuur",
    "out_of_service_value_should_be_a_number" : "De waarde van buiten gebruik moet een getal zijn",
    "out_of_service_cannot_be_negative" : "Buiten gebruik kan niet negatief zijn",
    "out_of_service_equipments_qty" : "Buiten gebruik gestelde apparatuur kan niet meer zijn dan het werkelijke aantal apparaten",
    "out_of_service_whole_number" : "Buiten gebruik moet een geheel getal zijn",
    "slot_duration_required" : "Duur van de tijdvak is vereist",
    "slot_duration_integer" : "De duur van het tijdvak moet een geheel getal zijn.",
    "meeting_duration_validation" : "De duur van de vergadering moet tussen 1 minuut en 12 uur liggen",
    "seats_class_required" : "Zetels per klas zijn vereist",
    "seats_class_integer" : "Zetels per klas moeten een geheel getal zijn",
    "seats_class_validation" : "Dit mag niet groter zijn dan 9999 of minder dan 0",
    "meeting_location_required" : "Vergaderlocatie is vereist"
  },
  "custom_values" : {
    "assigned_user" : "Toegewezen gebruiker",
    "full_name" : "Volledige naam",
    "first_name" : "Voornaam",
    "last_name" : "Achternaam",
    "email" : "E-mail",
    "phone" : "Telefoon",
    "twilio_phone" : "Twilio-telefoon",
    "account" : "Account",
    "name" : "Naam",
    "full_address" : "Volledig adres",
    "city" : "Stad",
    "state" : "Provincie",
    "country" : "Land",
    "postal_code" : "Postcode",
    "contact" : "Contact",
    "address1" : "Adres 1",
    "timezone" : "Tijdzone",
    "user" : "Gebruiker",
    "appointment" : "Afspraak",
    "start_date_time" : "Startdatum en -tijd",
    "start_date" : "Startdatum",
    "start_time" : "Starttijd",
    "end_date_time" : "Einddatum en -tijd",
    "end_date" : "Einddatum",
    "end_time" : "Eindtijd",
    "meeting_location" : "Vergaderlocatie"
  },
  "meeting_location_types" : {
    "zoom" : "Zoom",
    "google_meet" : "Google Meet",
    "phone" : "Telefoon",
    "full_address" : "Volledig adres",
    "microsoft_teams" : "Microsoft Teams",
    "custom" : "Aangepast"
  },
  "duration_units" : {
    "minutes" : "Minuten",
    "hours" : "Uur"
  },
  "widget_styles" : {
    "classic" : "Klassiek",
    "neo" : "Neo"
  },
  "feature_labels" : {
    "service_menu" : "Servicemenu",
    "rooms" : "Ruimtes",
    "equipments" : "Uitrusting"
  },
  "lsa" : {
    "categories" : {
      "accountant" : "Boekhouding",
      "acupuncturist" : "Acupunctuur",
      "air_duct_cleaner" : "Reiniging van luchtkanalen",
      "alcohol_treatment" : "Diensten voor behandeling van alcoholisme",
      "animal_shelter" : "Reddingsdiensten voor dieren",
      "appliance_repair" : "Apparaatreparatie",
      "architect" : "Architectuur",
      "assisted_living" : "Diensten voor begeleid wonen",
      "babysitter" : "Oppassen",
      "bankruptcy_lawyer" : "Faillissementsrecht",
      "beauty_school" : "Schoonheidsschool",
      "business_lawyer" : "Bedrijfsrecht",
      "car_repair" : "Automatische diensten",
      "carpenter" : "Timmerwerk",
      "carpet_cleaning" : "Tapijtreiniging",
      "child_care" : "Kinderopvangdiensten",
      "chiropractor" : "Chiropractische diensten",
      "cleaning_service" : "Huishoudelijke schoonmaak",
      "contract_lawyer" : "Contractenrecht",
      "countertop_pro" : "Aanrechtdiensten",
      "criminal_lawyer" : "Strafrecht",
      "dance_instructor" : "Dansinstructie",
      "disability_lawyer" : "Gehandicaptenrecht",
      "driving_instructor" : "Rijinstructie",
      "dui_lawyer" : "Wet op rijden onder invloed",
      "electrician" : "Elektrisch",
      "energy_efficiency_pro" : "Diensten voor energie-efficiëntie",
      "estate_lawyer" : "Erfrecht",
      "event_planner" : "Evenementenplanning",
      "family_lawyer" : "Familierecht",
      "fencing_pro" : "Schermen",
      "financial_planner" : "Financiële planning",
      "first_aid_trainer" : "EHBO-training",
      "flooring_pro" : "Vloeren",
      "foundation_pro" : "Basisprincipes",
      "funeral_home" : "Uitvaartdiensten",
      "garage_door_pro" : "Garagedeur",
      "general_contractor" : "Woningverbetering",
      "handyman" : "Klusjesman",
      "home_inspector" : "Woninginspectie",
      "home_security" : "Diensten voor woningbeveiliging",
      "home_theater" : "Thuisbioscoopdiensten",
      "hvac" : "HVAC",
      "immigration_lawyer" : "Immigratiewet",
      "interior_designer" : "Interieurontwerp",
      "ip_lawyer" : "Intellectueel eigendomsrecht",
      "junk_removal" : "Afvalverwijdering",
      "labor_lawyer" : "Arbeidsrecht",
      "landscaper" : "Tuinieren",
      "language_instructor" : "Taalinstructie",
      "lawn_care" : "Gazononderhoud",
      "litigation_lawyer" : "Procesrecht",
      "locksmith" : "Slotenmaker",
      "malpractice_lawyer" : "Aansprakelijkheidsrecht",
      "massage_center" : "Massagediensten",
      "massage_school" : "Massageschool",
      "mover" : "Bezig met verplaatsen",
      "nursing_home" : "Verpleeghuisdienst",
      "painter" : "Schilderen",
      "personal_injury_lawyer" : "Letselschaderecht",
      "personal_trainer" : "Persoonlijke training",
      "pest_control" : "Ongediertebestrijding",
      "pet_adoption" : "Services voor adoptie van huisdieren",
      "pet_boarding" : "Dierenopvang",
      "pet_grooming" : "Dierenverzorging",
      "pet_trainer" : "Huisdierentraining",
      "photographer" : "Fotografie",
      "plumber" : "Loodgieterswerk",
      "pool_cleaner" : "Zwembadreiniging",
      "pool_contractor" : "Zwembadcontractering",
      "preschool" : "Kleuteronderwijs",
      "psychologist" : "Psychologische diensten",
      "real_estate_agent" : "Onroerend goed",
      "real_estate_lawyer" : "Vastgoedrecht",
      "rehab" : "Revalidatiediensten",
      "roofer" : "Dakbedekking",
      "sewage_pro" : "Diensten voor rioleringssystemen",
      "siding_pro" : "Gevelbekleding",
      "smart_home" : "Slimme diensten aan huis",
      "snow_removal" : "Sneeuwruimdiensten",
      "spa" : "Spadiensten",
      "tax_lawyer" : "Belastingrecht",
      "tax_specialist" : "Fiscale dienstverlening",
      "therapist" : "Therapie",
      "towing_pro" : "Pechhulp",
      "traffic_lawyer" : "Verkeersrecht",
      "tree_service" : "Boomverzorgingsdiensten",
      "tutor" : "Bijles",
      "upholstery_cleaner" : "Meubelreiniging",
      "veterinarian" : "Veterinaire diensten",
      "videographer" : "Videodiensten",
      "water_damage" : "Diensten bij waterschade",
      "weight_loss_service" : "Diensten voor gewichtsverlies",
      "window_cleaner" : "Glasbewassing",
      "window_repair" : "Diensten voor ruiten",
      "windshield_repair_pro" : "Automatisch glas",
      "yoga_instructor" : "Yoga"
    },
    "job_types" : {
      "accountant_other" : "Anders",
      "bankruptcy_tax_litigation" : "Fiscale geschillen over faillissementen",
      "bookkeeping" : "Boekhouding",
      "business_consulting" : "Bedrijfsconsultancy",
      "debt_collection_relief" : "Schuldhulpverlening",
      "irs_representation_resolution" : "Fiscale vertegenwoordiging en probleemoplossing",
      "payroll" : "Salarisadministratie",
      "tax_planning_business" : "Zakelijke belastingplanning",
      "tax_planning_individual" : "Particuliere belastingplanning",
      "tax_return_business" : "Zakelijke belastingaangifte",
      "tax_return_individual" : "Particuliere belastingaangifte",
      "trusts_estates_accounting" : "Boekhouding voor trusts en nalatenschappen",
      "acupressure" : "Acupressuur",
      "acupuncture" : "Acupunctuur",
      "acupuncturist_other" : "Anders",
      "cupping" : "Cupping",
      "gua_sha" : "Gua Sha",
      "heat_therapy" : "Warmtetherapie",
      "herbal_therapy" : "Kruidengeneeskunde",
      "infrared_therapy" : "Infraroodtherapie",
      "moxibustion" : "Moxibustie",
      "qigong" : "Qigong",
      "shiatsu" : "Shiatsu",
      "tui_na" : "Tui Na",
      "air_duct_cleaning" : "Reiniging van luchtkanalen",
      "air_duct_filter_replacement" : "Filters vervangen",
      "air_duct_other" : "Anders",
      "dryer_vent_cleaning" : "Reiniging van drogerafvoer",
      "furnace_cleaning" : "Reiniging van oven",
      "indoor_air_quality_testing" : "Testen van de luchtkwaliteit binnen",
      "alcohol_treatment_other" : "Anders",
      "animal_shelter_cat_adoption" : "Kattenadoptie",
      "animal_shelter_dog_adoption" : "Hondenadoptie",
      "animal_shelter_other" : "Anders",
      "animal_shelter_other_animal_adoption" : "Adoptie van andere dieren",
      "animal_shelter_other_veterinary_services" : "Andere veterinaire diensten",
      "animal_shelter_spay_neuter" : "Steriliseren of castreren",
      "animal_shelter_vaccinations" : "Vaccinaties",
      "lost_stray_found_animals" : "Verloren, verdwaalde of gevonden dieren",
      "pet_license" : "Huisdierlicentie",
      "pet_surrender" : "Huisdieroverdracht",
      "appliance_other" : "Anders",
      "repair_dishwasher" : "Vaatwasser repareren",
      "repair_dryer" : "Droger repareren",
      "repair_freezer" : "Vriezer repareren",
      "repair_microwave" : "Magnetron repareren",
      "repair_oven" : "Oven repareren",
      "repair_refrigerator" : "Koelkast repareren",
      "repair_refrigerator_freezer" : "Koelkast / vriezer repareren",
      "repair_stove_cooktop" : "Fornuis / kookplaat repareren",
      "repair_stove_cooktop_oven" : "Fornuis / kookplaat / oven repareren",
      "repair_washer" : "Wasmachine repareren",
      "repair_washer_dryer" : "Wasmachine / droger repareren",
      "3d_architectural_rendering" : "3D architecturale rendering",
      "adaptive_reuse_historical_renovation" : "Adaptief hergebruik en historische renovatie",
      "architect_other" : "Anders",
      "architectural_designing" : "Architectonisch ontwerpen",
      "architectural_engineering" : "Bouwkundige engineering",
      "building_code_analysis_permit_coordination" : "Codeanalyse en vergunningen",
      "consulting" : "Advies",
      "home_building_improvement" : "Woningbouw en -verbetering",
      "interior_design_architect" : "Interieurontwerp",
      "planning_zoning_approval_assistance" : "Goedkeuring van bestemmingsplannen",
      "project_managing_architect" : "Projectbeheer",
      "site_master_planning" : "Masterplanning van locaties",
      "assisted_living_housekeeping_and_laundry" : "Huishouden en wasserij",
      "assisted_living_meal_services" : "Maaltijdservices",
      "assisted_living_memory_care" : "Geheugenzorg",
      "assisted_living_other" : "Anders",
      "assisted_living_rehabilitation_services" : "Revalidatiediensten",
      "assisted_living_transportation" : "Vervoer",
      "assisted_living_wellness_programs" : "Wellnessprogramma's",
      "daily_living_assistance" : "Hulp bij het dagelijks leven",
      "medication_management" : "Medicatiebeheer",
      "short_term_stays" : "Korte verblijven",
      "social_and_recreational_activities" : "Recreatieve activiteiten",
      "babysitter_other" : "Anders",
      "event_babysitting" : "Babysitten bij evenementen",
      "homework_assistance" : "Huiswerkbegeleiding",
      "housekeeping_laundry" : "Huishouden en wasserij",
      "meal_preparation" : "Maaltijdvoorbereiding",
      "nanny_services" : "Nannydiensten",
      "overnight_babysitting" : "Babysitten 's nachts",
      "pick_up_and_drop_off" : "Ophalen en afzetten",
      "shopping_errand" : "Winkelen en boodschappen doen",
      "special_needs_care" : "Speciale zorg",
      "virtual_babysitting" : "Virtueel babysitten",
      "agriculture_bankruptcy" : "Landbouwfaillissement",
      "bankruptcy_lawyer_other" : "Anders",
      "bankruptcy_litigation" : "Geschillen over faillissementen",
      "chapter_11_bankruptcy" : "Chapter 11-faillissement",
      "chapter_13_bankruptcy" : "Chapter 13-faillissement",
      "chapter_7_bankruptcy" : "Chapter 7-faillissement",
      "corporate_bankruptcy" : "Bedrijfsfaillissement",
      "creditor_harassment" : "Crediteurintimidatie",
      "debt_settlement" : "Schuldenregeling",
      "foreclosure_bankruptcy_lawyer" : "Executieverkoop",
      "personal_bankruptcy" : "Persoonlijk faillissement",
      "repossession" : "Terugname",
      "wage_garnishment" : "Loonbeslag",
      "beauty_school_barbering" : "Barber",
      "beauty_school_business_management" : "Bedrijfsbeheer",
      "beauty_school_cosmetology" : "Cosmetologie",
      "beauty_school_esthetics" : "Esthetiek",
      "beauty_school_hair_cutting" : "Haarknippen",
      "beauty_school_hair_design" : "Haarontwerp",
      "beauty_school_makeup" : "Make-up",
      "beauty_school_massage_therapy" : "Massagetherapie",
      "beauty_school_nail_technology" : "Nageltechnologie",
      "beauty_school_other" : "Anders",
      "beauty_school_retail_training" : "Retailtraining",
      "banking_finance_law" : "Bankwezen en financiën",
      "business_lawyer_other" : "Anders",
      "business_licenses_permits" : "Zakelijke licenties en vergunningen",
      "business_litigation" : "Zakelijke geschillen",
      "business_taxes" : "Zakelijke belastingen",
      "business_transactions_business_lawyer" : "Zakelijke transacties",
      "commercial_bankruptcy" : "Zakelijk faillissement",
      "commercial_contracts_business_lawyer" : "Commerciële contracten",
      "employment_law_business_lawyer" : "Arbeidsrecht",
      "incorporation_restructuring" : "Oprichting en herstructurering",
      "insurance_law" : "Verzekeringsrecht",
      "intellectual_property_law" : "Intellectueel eigendomsrecht",
      "mergers_acquisitions_business_lawyer" : "Fusies en overnames",
      "partnership_agreements_business_lawyer" : "Partnerschapsovereenkomsten",
      "patents_copyrights_trademarks" : "Patenten, auteursrechten en handelsmerken",
      "securities_law" : "Effectenrecht",
      "shareholder_disputes" : "Geschillen met aandeelhouders",
      "air_and_cabin_filter" : "Lucht- en cabinefilter",
      "battery" : "Batterij",
      "body_and_trim" : "Lichaam en trimmen",
      "brakes" : "Remmen",
      "car_air_conditioning" : "Airconditioning",
      "car_electrical" : "Elektrisch",
      "car_repair_other" : "Anders",
      "check_engine_light_diagnostic" : "Diagnose motorcontrolelampje",
      "exhaust" : "Uitlaat",
      "oil_change" : "Olie verversen",
      "steering_suspension" : "Stuurinrichting / ophanging",
      "tires" : "Banden",
      "transmission" : "Transmissie",
      "cabinetry" : "Kastenbouw",
      "carpenter_other" : "Anders",
      "decking" : "Terrasplanken",
      "drywalling" : "Gipsplaten plaatsen",
      "fencing" : "Schermen",
      "general_installations" : "Algemene installaties",
      "general_repairs_maintenance" : "Algemene reparaties en onderhoud",
      "remodeling" : "Renovatie",
      "shelving_storage" : "Rekken en opslag",
      "carpet_cleaning_other" : "Anders",
      "clean_area_rugs" : "Vloerkleden reinigen",
      "clean_carpet" : "Tapijt reinigen",
      "clean_drapes_and_curtains" : "Voiles en gordijnen reinigen",
      "clean_upholstery" : "Bekleding reinigen",
      "remove_pet_stains_and_odors" : "Vlekken en geurtjes verwijderen bij huisdieren",
      "after_school_care" : "Naschoolse opvang",
      "all_hours_daycare" : "Kinderopvang voor alle uren",
      "bilingual_daycare" : "Tweetalige kinderopvang",
      "child_care_other" : "Anders",
      "drop_in_daycare" : "Inloopkinderopvang",
      "full_time_daycare" : "Voltijds kinderopvang",
      "in_home_daycare" : "Dagopvang aan huis",
      "infant_programs" : "Babyprogramma's",
      "part_time_daycare" : "Deeltijd kinderopvang",
      "pre_kindergarten_programs" : "Programma's voorafgaand aan de kleuterschool",
      "preschool_programs" : "Voorschoolse programma's",
      "school_age_programs" : "Programma's voor schoolgaande kinderen",
      "special_needs_daycare" : "Kinderopvang speciaal onderwijs",
      "summer_daycare" : "Zomerdagopvang",
      "toddler_programs" : "Peuterprogramma's",
      "weekend_daycare" : "Weekendkinderopvang",
      "chiropractor_acupuncture" : "Acupunctuur",
      "chiropractor_chiropractic" : "Chiropractie",
      "chiropractor_massage_therapy" : "Massagetherapie",
      "chiropractor_other" : "Anders",
      "diagnosis" : "Diagnose",
      "eastern_medicine" : "Oosterse geneeskunde",
      "exercise_counseling" : "Bewegingsadvies",
      "pain_management" : "Pijnbeheer",
      "physical_therapy" : "Fysiotherapie",
      "spinal_adjustments" : "Rugcorrecties",
      "sports_medicine" : "Sportgeneeskunde",
      "cleaner_other" : "Anders",
      "deep_clean" : "Grondige schoonmaak",
      "moving_clean" : "Schoonmaak bij verhuizing",
      "office_clean" : "Kantoor schoonmaken",
      "standard_clean" : "Normale schoonmaak",
      "assignment_of_contract" : "Toewijzing van contract",
      "business_transactions_contract_lawyer" : "Zakelijke transacties",
      "commercial_contracts_contract_lawyer" : "Commerciële contracten",
      "contract_dispute" : "Contractgeschil",
      "contract_lawyer_other" : "Anders",
      "contract_negotiation" : "Contractonderhandeling",
      "contract_review" : "Contractbeoordeling",
      "employment_contracts_contract_lawyer" : "Arbeidsovereenkomsten",
      "franchise_agreements" : "Franchiseovereenkomsten",
      "mergers_acquisitions_contract_lawyer" : "Fusies en overnames",
      "non_disclosure_agreements_contract_lawyer" : "Geheimhoudingsovereenkomsten",
      "partnership_agreements_contract_lawyer" : "Partnerschapsovereenkomsten",
      "power_of_attorney_contract_lawyer" : "Volmacht",
      "security_agreements" : "Beveiligingsovereenkomsten",
      "warranties" : "Garanties",
      "bathroom_countertops" : "Badkamerbladen",
      "bathroom_wall_panels" : "Badkamerwandpanelen",
      "countertop_design" : "Aanrechtbladontwerp",
      "countertop_installation" : "Aanrechtbladinstallatie",
      "countertop_pro_other" : "Anders",
      "fireplace_facade" : "Openhaardgevel",
      "granite_countertops" : "Granieten aanrechtbladen",
      "kitchen_countertops" : "Keukenwerkbladen",
      "kitchen_wall_panels" : "Keukenwandpanelen",
      "laminate_countertops" : "Werkbladen van laminaat",
      "marble_countertops" : "Marmeren werkbladen",
      "quartz_countertops" : "Kwarts werkbladen",
      "remodeling_countertop_pro" : "Renovatie",
      "repair_maintenance_countertop_pro" : "Reparatie en onderhoud",
      "stone_slab_countertops" : "Stenen werkbladen",
      "tile_countertops" : "Tegelwerkbladen",
      "corporate_representation" : "Bedrijfsvertegenwoordiging",
      "criminal_immigration_defense" : "Strafrechtelijke Immigratieverdediging",
      "criminal_lawyer_other" : "Anders",
      "domestic_violence" : "Huiselijk geweld",
      "drug_possession" : "Drugsbezit",
      "duis_reckless_driving" : "Rijden onder invloed en roekeloos rijden",
      "expungement" : "Uitzetting",
      "federal_crimes" : "Federale misdrijven",
      "felonies" : "Zware misdrijven",
      "petty_crimes_misdemeanors" : "Kleine misdrijven en overtredingen",
      "restraining_orders" : "Huisverboden",
      "sex_offenses" : "Seksuele misdrijven",
      "three_strikes_law" : "Three-strikes-wet",
      "dance_instructor_african" : "Afrikaans",
      "dance_instructor_ballet" : "Ballet",
      "dance_instructor_ballroom" : "Balzaal",
      "dance_instructor_belly" : "Buik",
      "dance_instructor_bollywood" : "Bollywood",
      "dance_instructor_contemporary" : "Modern",
      "dance_instructor_folk_traditional" : "Folk en traditioneel",
      "dance_instructor_hip_hop" : "Hip Hop",
      "dance_instructor_jazz" : "Jazz",
      "dance_instructor_kids_classes" : "Lessen voor kinderen",
      "dance_instructor_latin" : "Latijn",
      "dance_instructor_modern" : "Modern",
      "dance_instructor_other" : "Anders",
      "dance_instructor_tap" : "Tik",
      "dance_instructor_wedding" : "Bruiloft",
      "disability_hearings" : "Hoorzittingen over handicaps",
      "disability_lawyer_other" : "Anders",
      "long_term_disability" : "Langdurige arbeidsongeschiktheid",
      "short_term_disability" : "Kortdurende arbeidsongeschiktheid",
      "social_security_disability_insurance" : "Arbeidsongeschiktheidsverzekering vanuit sociale zekerheid",
      "ssa_claim_reconsideration" : "Heroverweging van de SSA-claim",
      "ssa_disability_appeals" : "Bezwaren arbeidsongeschiktheid SSA",
      "ssa_disability_applications" : "Aanvragen arbeidsongeschiktheid SSA",
      "ssa_disability_benefits" : "SSA-uitkeringen voor arbeidsongeschiktheid",
      "ssa_family_benefits" : "SSA-uitkeringen voor gezinsleden",
      "ssa_impairment_listings" : "SSA-beperkingenlijsten",
      "supplemental_security_income" : "Aanvullende sociale zekerheid",
      "veterans_disability_benefits" : "Uitkeringen voor veteranen met een handicap",
      "workers_compensation_disability_lawyer" : "Werknemerscompensatie",
      "behind_the_wheel_lessons" : "Lessen achter het stuur",
      "commercial_license_training" : "Commerciële licentiecursussen",
      "defensive_driving_lessons" : "Lessen defensief rijden",
      "drivers_education_classes" : "Rijopleidingen",
      "driving_instructor_other" : "Anders",
      "manual_transmission_lessons" : "Lessen over handgeschakelde versnellingsbakken",
      "motorcycle_lessons" : "Motorrijlessen",
      "traffic_school" : "Verkeersschool",
      "dui_dwi_dui_lawyer" : "DUI/DWI",
      "dui_injuries_dui_lawyer" : "DUI met letsel",
      "dui_lawyer_other" : "Anders",
      "dui_with_accident" : "DUI met ongeval",
      "felony_dui" : "Zware overtreding DUI",
      "invalid_tests" : "Vervallen tests",
      "multiple_offenses" : "Meerdere overtredingen",
      "reckless_driving_dui_lawyer" : "Roekeloos rijden",
      "underage_dui" : "DUI door minderjarigen",
      "electric_car_charger" : "Lader voor elektrische auto installeren",
      "electrician_other" : "Anders",
      "electrician_remodeling" : "Verbouwen",
      "install_fan" : "Ventilator installeren",
      "install_ground_wire" : "Aardingsdraad installeren",
      "install_light_fixtures" : "Lichtarmaturen installeren",
      "install_outdoor_lighting" : "Buitenverlichting installeren",
      "install_outlets_switches" : "Stopcontacten of schakelaars installeren",
      "install_security_system" : "Beveiligingssysteem installeren",
      "relocate_outlets_switches" : "Stopcontacten of schakelaars verplaatsen",
      "repair_fan" : "Ventilator repareren",
      "repair_light_fixtures" : "Lichtarmaturen repareren",
      "repair_outlets_switches" : "Stopcontacten of schakelaars repareren",
      "repair_panel" : "Paneel repareren",
      "replace_upgrade_panel" : "Paneel vervangen of upgraden",
      "restore_power" : "Stroom herstellen",
      "energy_efficiency_pro_other" : "Anders",
      "charitable_giving" : "Liefdadigheidsbijdrage",
      "contests_litigation" : "Geschillen / rechtszaken",
      "deeds" : "Aktes",
      "estate_lawyer_other" : "Anders",
      "estate_planning_lawyer" : "Vermogensplanning",
      "guardianship_estate_lawyer" : "Voogdij",
      "medical_power_of_attorney" : "Medische volmacht",
      "power_of_attorney_estate_lawyer" : "Volmacht",
      "probate_estate_lawyer" : "Erfrechtadvocaat",
      "trusts" : "Trusts",
      "wills" : "Testamenten",
      "anniversary_planner" : "Jubileum",
      "baby_shower_planner" : "Babyshower",
      "bar_and_bat_mitzvah_planner" : "Bar en Bat Mitswa",
      "birthday_party" : "Verjaardagsfeestje",
      "children_party" : "Kinderfeestje",
      "corporate_and_conference_planner" : "Zakelijk en conferentie",
      "event_planner_other" : "Anders",
      "quinceanera_planner" : "Quinceanera",
      "religious_event" : "Religieus evenement",
      "retirement_party" : "Pensioenfeest",
      "school_event" : "Schoolevenement",
      "theme_party" : "Themafeest",
      "wedding_and_engagement_planner" : "Bruiloft en verloving",
      "adoption" : "Adoptie",
      "child_support" : "Kinderbijslag",
      "contested_divorce" : "Betwiste echtscheiding",
      "debt_division" : "Schuldenverdeling",
      "family_lawyer_other" : "Anders",
      "guardianship_family_lawyer" : "Voogdij",
      "mediation_family_lawyer" : "Mediation",
      "modifications_of_orders" : "Wijziging van bestellingen",
      "parent_timesharing" : "Timesharing voor ouders",
      "paternity" : "Vaderschap",
      "prenuptial_postnuptial_agreements" : "Huwelijkse voorwaarden en huwelijkscontracten",
      "probate_family_lawyer" : "Erfrecht",
      "property_divisions" : "Eigendomsscheiding",
      "protective_orders_domestic_violence_issues" : "Huisverboden",
      "spousal_support_alimony" : "Partneralimentatie en alimentatie",
      "uncontested_divorce" : "Onbetwiste echtscheiding",
      "custom_construction" : "Aangepaste constructie",
      "fence_design" : "Ontwerp van omheining",
      "fencing_other" : "Anders",
      "installation_fencing_pro" : "Installatie van omheining",
      "repairs_maintenance_fencing_pro" : "Reparaties en onderhoud",
      "education_savings" : "Besparingen op onderwijs",
      "estate_financial_planning" : "Vermogensplanning",
      "financial_planning" : "Financiële planning",
      "financial_planning_other" : "Anders",
      "home_purchase" : "Aankoop van een woning",
      "insurance" : "Verzekering",
      "investment_advising" : "Beleggingsadvies",
      "retirement_savings" : "Pensioen",
      "tax_planning" : "Fiscale planning",
      "advanced_cardiac_life_support" : "Geavanceerde cardiale beademing",
      "aed_defibrillator" : "AED - Defibrillator",
      "basic_life_support" : "Eenvoudige beademing",
      "cpr" : "CPR",
      "first_aid" : "Eerste hulp",
      "first_aid_trainer_other" : "Anders",
      "pediatric_advanced_life_support" : "Pediatrische geavanceerde beademing",
      "pediatric_cpr_first_aid" : "Pediatrische reanimatie en eerste hulp",
      "pet_cpr_first_aid" : "Reanimatie en eerste hulp bij huisdieren",
      "wilderness_first_aid" : "Eerste hulp in de wildernis",
      "baseboards" : "Plinten",
      "carpet" : "Tapijt",
      "flooring_other" : "Anders",
      "hardwood" : "Hardhout",
      "installation_flooring_pro" : "Vloeren installeren",
      "marble" : "Marmer",
      "polishing" : "Vloer polijsten",
      "refinishing" : "Vloerrenovatie",
      "repair_maintenance_flooring_pro" : "Vloerreparatie en -onderhoud",
      "stair_flooring" : "Trapbekleding",
      "tile" : "Tegel",
      "wood_floor_sanding" : "Schuurwerk voor houten vloeren",
      "basement_waterproofing" : "Kelder waterdicht maken",
      "crawl_spaces" : "Fundering van kruipruimte",
      "foundation_drainage" : "Funderingsdrainage",
      "foundation_installation" : "Installatie fundering",
      "foundation_pro_other" : "Anders",
      "foundation_raising" : "Funderingsverhoging",
      "repairs_maintenance_foundation_pro" : "Reparaties en onderhoud",
      "slab_foundation" : "Plaatfundering",
      "steel_pier_pilings" : "Stalen pierpalen",
      "water_moisture_control" : "Water- en vochtbeheer",
      "burials" : "Begrafenissen",
      "caskets" : "Doodskisten",
      "cremation" : "Crematie",
      "funeral_home_flowers" : "Bloemen",
      "funeral_home_other" : "Anders",
      "funeral_home_transportation_transfers" : "Vervoer en transfers",
      "funeral_home_veteran_services" : "Diensten voor veteranen",
      "funerals" : "Begrafenissen",
      "gravestones" : "Grafstenen",
      "grief_services" : "Rouwdiensten",
      "memorials" : "Gedenktekens",
      "urns" : "Urnen",
      "garage_door_other" : "Anders",
      "general_maintenance" : "Algemeen onderhoud",
      "install_garage_door" : "Garagedeur installeren",
      "install_opener" : "Opener installeren",
      "repair_cables" : "Kabels repareren",
      "repair_garage_door" : "Garagedeur repareren",
      "repair_gate" : "Poort repareren",
      "repair_rollers_tracks" : "Rollen en rupsbanden repareren",
      "replace_door_panels" : "Deurpanelen vervangen",
      "replace_opener" : "Opener vervangen",
      "replace_springs" : "Veren vervangen",
      "accessory_buildings" : "Bijgebouwen",
      "bathroom_remodel" : "Badkamer verbouwen",
      "decks_patio" : "Terrassen en patio",
      "exterior_finishing" : "Buitenafwerking",
      "foundations_concrete" : "Funderingen en Beton",
      "general_contractor_commercial_projects" : "Commerciële projecten",
      "general_contractor_other" : "Anders",
      "home_addition" : "Woninguitbreiding",
      "home_building" : "Woningbouw",
      "home_remodel_renovation" : "Woningrenovatie en verbouwing",
      "interior_finishing" : "Interieurafwerking",
      "kitchen_remodel" : "Keukenrenovatie",
      "roofing" : "Dakbedekking",
      "assemble_furniture" : "Meubels samenstellen",
      "clean_gutters" : "Dakgoten schoonmaken",
      "handyman_other" : "Anders",
      "install_drywall" : "Gipsplaat installeren",
      "install_flooring" : "Vloeren leggen",
      "install_tile" : "Tegel installeren",
      "install_water_fixtures" : "Waterarmaturen installeren",
      "mount_tv" : "TV monteren",
      "paint_indoors" : "Binnen schilderen",
      "paint_outdoors" : "Buiten schilderen",
      "repair_drywall" : "Gipsplaten repareren",
      "repair_flooring" : "Vloer repareren",
      "repair_water_fixtures" : "Waterinstallaties repareren",
      "replace_tile" : "Tegel vervangen",
      "buyer_seller_inspection" : "Koper-verkoperinspectie",
      "commercial_properties" : "Commercieel vastgoed",
      "fire_safety" : "Brandveiligheid",
      "fireplace_chimney" : "Open haard en schoorsteen",
      "full_home_inspection" : "Volledige woninginspectie",
      "home_inspector_electrical" : "Elektrisch",
      "home_inspector_foundation" : "Fundering",
      "home_inspector_hvac" : "HVAC",
      "home_inspector_mold" : "Schimmel",
      "home_inspector_new_construction" : "Nieuwbouw",
      "home_inspector_other" : "Anders",
      "home_inspector_plumbing" : "Loodgieterswerk",
      "home_inspector_roof" : "Dak",
      "home_inspector_structural" : "Structureel",
      "home_warranty" : "Woninggarantie",
      "water_testing" : "Watertesten",
      "well_or_septic_system" : "Put of septisch systeem",
      "wood_insects" : "Hout en insecten",
      "access_control" : "Toegangscontrole",
      "alarm_systems" : "Alarmsystemen",
      "commercial_security_systems" : "Commerciële beveiligingssystemen",
      "fire_smoke_detection" : "Brand- en rookdetectie",
      "home_security_doors" : "Deuren",
      "home_security_locks" : "Vergrendelingen",
      "home_security_other" : "Anders",
      "home_security_windows" : "Vensters",
      "monitoring_services" : "Monitoringsdiensten",
      "residential_security_systems" : "Beveiligingssystemen voor woningen",
      "smart_home_integration" : "Smart home-integratie",
      "video_surveillance" : "Videobewaking",
      "audio_video_installation" : "Audio- en video-installatie",
      "commercial_projects" : "Commerciële projecten",
      "home_theater_design" : "Ontwerp van thuisbioscoop",
      "home_theater_lighting" : "Verlichting",
      "home_theater_other" : "Anders",
      "home_theater_smart_home_integration" : "Smart home-integratie",
      "install_tv" : "TV installeren",
      "network_it_services" : "Netwerk- en IT-diensten",
      "outdoor_installations" : "Buiteninstallaties",
      "soundproofing" : "Geluidsisolatie",
      "whole_house_audio_video" : "Audio en video voor het hele huis",
      "ac_maintenance" : "AC-onderhoud",
      "clean_ducts_vents" : "Kanalen en ventilatieopeningen schoonmaken",
      "ductless_heating_and_ac_services" : "Diensten voor verwarmingen en airconditionings zonder leidingen",
      "heating_maintenance" : "Verwarmingsonderhoud",
      "hvac_maintenance" : "HVAC-onderhoud",
      "hvac_other" : "Anders",
      "install_ac" : "Installeren airconditioning",
      "install_ducts_vents" : "Leidingen en ventilatieopeningen installeren",
      "install_heating_system" : "Verwarmingssysteem installeren",
      "install_thermostat" : "Thermostaat installeren",
      "repair_ac" : "Airco repareren",
      "repair_ducts_vents" : "Reparatie van leidingen en ventilatieopeningen",
      "repair_heating_system" : "Verwarmingssysteem repareren",
      "repair_hvac" : "HVAC repareren",
      "repair_thermostat" : "Thermostaat repareren",
      "asylum" : "Asiel",
      "citizenship" : "Burgerschap",
      "deportation" : "Deportatie",
      "family_based_immigration" : "Familiegebonden immigratie",
      "green_card" : "Green card",
      "immigration_lawyer_other" : "Anders",
      "investment_visa" : "Investeringsvisum",
      "outbound_work_permits" : "Uitgaande werkvergunningen",
      "student_visa" : "Studentenvisum",
      "visitor_visa" : "Bezoekersvisum",
      "work_visa" : "Werkvisum",
      "appliance_selection" : "Selectie van apparaten",
      "cabinetry_molding_hardware_design" : "Ontwerp van kasten en hardware",
      "decorating" : "Decoreren",
      "door_design" : "Ontwerp van deuren",
      "exterior_building_design" : "Ontwerp van exterieur van gebouwen",
      "flooring_selection" : "Selectie van vloeren",
      "interior_designer_other" : "Anders",
      "landscaping_design" : "Tuinontwerp",
      "lighting_design" : "Verlichtingsontwerp",
      "multifamily_housing_design" : "Opmaak van meergezinswoningen",
      "room_planning" : "Ruimteplanning",
      "stone_brick_stucco_design" : "Onwerp van steen, baksteen en stucwerk",
      "window_design" : "Vensterontwerp",
      "advertisements" : "Advertenties",
      "copyright" : "Auteursrecht",
      "export_control" : "Exportcontrole",
      "franchises" : "Franchises",
      "international_ip" : "Internationaal IP",
      "ip_lawyer_other" : "Anders",
      "ip_strategy" : "IP-strategie",
      "ip_transactions" : "IP-transacties",
      "licensing" : "Licenties",
      "litigation_ip_lawyer" : "Procesvoering",
      "non_disclosure_agreements_ip_lawyer" : "Geheimhoudingsovereenkomsten",
      "patents" : "Patenten",
      "technology_transfer" : "Overdracht van technologie",
      "trade_secrets" : "Handelsgeheimen",
      "trademarks" : "Handelsmerken",
      "appliance_removal" : "Verwijderen van apparatuur",
      "construction_waste_removal" : "Verwijderen van bouwafval",
      "donation_pickup" : "Donatie ophalen",
      "electronic_waste_removal" : "Verwijdering van elektronisch afval",
      "furniture_removal" : "Verwijderen van meubels",
      "general_junk_removal" : "Verwijderen van afval",
      "hazardous_waste_removal" : "Verwijdering van gevaarlijk afval",
      "house_garage_cleanout" : "Schoonmaak van woning/garage",
      "junk_removal_other" : "Anders",
      "yard_waste_removal" : "Verwijderen van tuinafval",
      "employment_contracts_labor_lawyer" : "Arbeidsovereenkomsten",
      "employment_law_labor_lawyer" : "Arbeidsrecht",
      "exempt_employee_status" : "Vrijgestelde werknemersstatus",
      "labor_law" : "Arbeidsrecht",
      "labor_lawyer_other" : "Anders",
      "labor_negotiations" : "Arbeidsonderhandelingen",
      "privacy_rights" : "Privacyrechten",
      "sexual_harassment" : "Seksuele intimidatie",
      "unpaid_overtime" : "Onbetaalde overuren",
      "whistle_blowing" : "Klokkenluiden",
      "workers_compensation_labor_lawyer" : "Werknemerscompensatie",
      "wrongful_termination" : "Onrechtmatige beëindiging",
      "artificial_turf_installation" : "Installatie van kunstgras",
      "concrete_masonry" : "Betonmetselwerk",
      "driveway_landscaping" : "Opritarchitectuur",
      "garden_decorations" : "Tuindecoraties",
      "grading_resloping" : "Gradering en herindeling",
      "hardscapes" : "Hardscapes",
      "landscape_design" : "Landschapsontwerp",
      "landscape_installations" : "Landschapsinstallaties",
      "landscaper_other" : "Anders",
      "outdoor_steps" : "Buitentrappen",
      "outdoor_water_feature" : "Waterpartijen buiten",
      "paving_driveway_walkway" : "Oprit of looppad bestrating",
      "retaining_walls" : "Keermuren",
      "sidewalk_walkway_landscaping" : "Padlandschapsarchitectuur",
      "sod_seeding" : "Graszoden en zaaien",
      "stone_masonry" : "Stenen metselwerk",
      "arabic" : "Arabic",
      "english" : "English",
      "french" : "French",
      "german" : "German",
      "hebrew" : "Hebreeuws",
      "italian" : "Italian",
      "japanese" : "Japanese",
      "korean" : "Korean",
      "language_instructor_other" : "Anders",
      "mandarin" : "Mandarijn",
      "portuguese" : "Portugees",
      "russian" : "Russian",
      "sign_language" : "Sign Language",
      "spanish" : "Spanish",
      "irrigation_system_repair_maintenance" : "Reparatie/onderhoud van irrigatiesysteem",
      "lawn_care_other" : "Anders",
      "lawn_mowing_maintenance" : "Gazon maaien/onderhoud",
      "lawn_pest_control" : "Ongediertebestrijding gazon",
      "mulching" : "Mulchen",
      "seeding" : "Zaaien",
      "sod_installation" : "Installatie van graszoden",
      "weed_control" : "Onkruidbestrijding",
      "yard_cleanup" : "Tuin opruimen",
      "appeals" : "Beroepen",
      "case_assessment_litigation_lawyer" : "Zaakevaluatie",
      "civil_litigation" : "Civiele rechtszaken",
      "commercial_litigation" : "Commerciële geschillen",
      "contracts_and_agreements" : "Contracten en Overeenkomsten",
      "criminal_litigation" : "Strafrechtelijke procesvoering",
      "litigation_lawyer_other" : "Anders",
      "mediation_litigation_lawyer" : "Mediation",
      "settlements" : "Schikkingen",
      "building_lockout" : "Buitensluiting gebouw",
      "copy_building_key" : "Gebouwsleutels kopiëren",
      "copy_vehicle_key" : "Voertuigsleutel kopiëren",
      "install_hardware" : "Hardware installeren",
      "locksmith_other" : "Anders",
      "new_key_fob" : "Nieuwe sleutelhouder",
      "rekey_lock" : "Slot opnieuw vergrendelen",
      "repair_hardware" : "Hardware repareren",
      "vehicle_lockout" : "Buitensluiting voertuig",
      "consent_issues" : "Problemen met instemming",
      "diagnosis_errors" : "Diagnosefouten",
      "malpractice_lawyer_other" : "Anders",
      "medical_negligence" : "Medische nalatigheid",
      "treatment_errors" : "Behandelingsfouten",
      "massage_center_other" : "Anders",
      "massage_school_advanced_neuromuscular_therapy" : "Geavanceerde neuromusculaire therapie",
      "massage_school_business_and_ethics" : "Bedrijfsleven en ethiek",
      "massage_school_clinical_therapies" : "Klinische therapieën",
      "massage_school_continuing_education" : "Voortgezet onderwijs",
      "massage_school_deep_tissue_massage" : "Diepe weefselmassage",
      "massage_school_energetics" : "Energetica",
      "massage_school_hydrotherapy" : "Hydrotherapie",
      "massage_school_lymphatic_massage" : "Lymfatische massage",
      "massage_school_online_massage_therapy" : "Online Massagetherapie",
      "massage_school_other" : "Anders",
      "massage_school_prenatal_massage" : "Prenatale massage",
      "massage_school_sports_massage" : "Sportmassage",
      "massage_school_student_massage_clinic" : "Studentenmassagekliniek",
      "massage_school_swedish_massage" : "Zweedse massage",
      "massage_theory" : "Massagetheorie",
      "massage_therapy_training" : "Cursussen massagetherapie",
      "in_state_move" : "Verhuizing binnen de provincie",
      "local_move" : "Lokale verhuizing",
      "mover_other" : "Anders",
      "moving_junk_removal" : "Afvalverwijdering",
      "moving_storage" : "Opslag",
      "out_of_state_move" : "Verhuizing buiten de provincie",
      "oversized_item_move" : "Extra groot item verplaatsen",
      "packing_unpacking" : "Inpakken/uitpakken",
      "senior_move" : "Seniorenverhuizing",
      "vehicle_transport" : "Voertuigtransport",
      "cardiac_care" : "Cardiale zorg",
      "general_medical_care" : "Algemene medische zorg",
      "hospice" : "Hospice",
      "iv_therapy" : "IV-therapie",
      "nursing_home_meal_services" : "Maaltijdservices",
      "nursing_home_memory_care" : "Geheugenzorg",
      "nursing_home_other" : "Anders",
      "nursing_home_pain_management" : "Pijnbeheer",
      "nursing_home_rehabilitation_services" : "Revalidatiediensten",
      "nursing_home_wellness_programs" : "Wellnessprogramma's",
      "outpatient_rehabilitation" : "Ambulante revalidatie",
      "post_hospital_care" : "Nazorg na ziekenhuisopname",
      "respiratory_and_pulmonary_care" : "Ademhalings- en longzorg",
      "senior_activity_programs" : "Activiteitenprogramma's voor senioren",
      "short_term_rehabilitation" : "Revalidatie op korte termijn",
      "wound_care" : "Wondverzorging",
      "exterior_painting" : "Buitenschilderwerk",
      "interior_painting" : "Binnenschilderwerk",
      "paint_cabinets" : "Kasten schilderen",
      "paint_doors" : "Deuren schilderen",
      "painter_other" : "Anders",
      "repair_water_damage" : "Waterschade herstellen",
      "staining" : "Kleuring",
      "assault_battery" : "Aanval en mishandeling",
      "auto_accidents" : "Automatische ongelukken",
      "bicycle_accidents" : "Fietsongevallen",
      "catastrophic_injuries" : "Catastrofale verwondingen",
      "dog_bites" : "Hondenbeten",
      "dui_injuries_personal_injury_lawyer" : "Verwondingen door rijden onder invloed",
      "medical_malpractice" : "Medische wanpraktijk",
      "motorcycle_accidents" : "Ongevallen met motorfietsen",
      "pain_suffering" : "Pijn en lijden",
      "pedestrian_accidents" : "Voetgangersongevallen",
      "personal_injury_lawyer_other" : "Anders",
      "product_liability" : "Productaansprakelijkheid",
      "slip_fall" : "Uitglijden & Vallen",
      "uninsured_motorist_claims" : "Schadeclaims voor automobilistenverzekeringen",
      "workers_compensation_personal_injury_lawyer" : "Werknemerscompensatie",
      "wrongful_death" : "Onrechtmatige dood",
      "aerobics" : "Aerobics",
      "athletic_performance" : "Atletische prestaties",
      "circuit_training" : "Circuittraining",
      "endurance" : "Uithoudingsvermogen",
      "fitness_assessment" : "Fitheidsevaluatie",
      "hiit" : "HIIT",
      "nutritional_counseling" : "Voedingsadvies",
      "personal_trainer_other" : "Anders",
      "strength_conditioning" : "Kracht en Conditie",
      "weight_loss" : "Gewichtsverlies",
      "yoga" : "Yoga",
      "ants" : "Mieren",
      "bed_bugs" : "Bedwantsen",
      "bees" : "Bijen",
      "cockroaches" : "Kakkerlakken",
      "fleas_or_mites" : "Vlooien of mijten",
      "hornets_or_wasps" : "Horzels of wespen",
      "mosquitoes" : "Muggen",
      "pest_control_other" : "Anders",
      "pest_inspection" : "Inspectie",
      "rodents" : "Knaagdieren",
      "spiders" : "Spinnen",
      "termites" : "Termieten",
      "wildlife" : "Wildlife",
      "pet_adoption_birds" : "Vogels",
      "pet_adoption_cats" : "Katten",
      "pet_adoption_dogs" : "Honden",
      "pet_adoption_farm_animals" : "Boerderijdieren",
      "pet_adoption_fish" : "Vis",
      "pet_adoption_other" : "Anders",
      "pet_adoption_reptiles" : "Reptielen",
      "pet_adoption_small_mammals" : "Kleine zoogdieren",
      "pet_adoption_special_needs_animals" : "Dieren met speciale behoeften",
      "cat_boarding" : "Kattenpension",
      "cat_grooming" : "Kattenverzorging",
      "cat_sitting_in_home" : "Kattenoppas (in huis)",
      "dog_boarding" : "Hondenopvang",
      "dog_boarding_with_training" : "Hondenpension met cursussen",
      "dog_daycare" : "Hondendagopvang",
      "dog_grooming" : "Hondenverzorging",
      "dog_sitting_in_home" : "Hondenoppas (in huis)",
      "dog_training" : "Hondentraining",
      "dog_walking" : "Hond uitlaten",
      "other_pet_boarding" : "Andere huisdierenopvang",
      "other_pet_daycare" : "Andere dagopvang voor huisdieren",
      "other_pet_grooming" : "Andere verzorging van huisdieren",
      "other_pet_sitting_in_home" : "Andere dierenoppas (in huis)",
      "pet_boarding_other" : "Anders",
      "cat_bathing" : "Kattenbaden",
      "cat_ear_cleaning" : "Kattenoorreiniging",
      "cat_grooming_and_styling" : "Kattenverzorging en -styling",
      "cat_nail_trimming" : "Kattennagels knippen",
      "dog_anal_gland_expression" : "Uitdrukking van de anale klier van de hond",
      "dog_bathing_and_blow_dry" : "Honden baden en föhnen",
      "dog_ear_cleaning" : "Hondenoorreiniging",
      "dog_flea_and_tick_treatment" : "Behandeling tegen vlooien en teken bij honden",
      "dog_full_service_grooming" : "Full-service hondenverzorging",
      "dog_grooming_and_styling" : "Hondenverzorging en -styling",
      "dog_nail_trimming" : "Nagels knippen van de hond",
      "dog_teeth_brushing" : "Tandenreiniging van honden",
      "pet_grooming_other" : "Anders",
      "aggressive_dog_training" : "Training voor agressieve honden",
      "behavior_modification" : "Gedragsverandering",
      "obedience_training" : "Gehoorzaamheidstraining",
      "offleash_training" : "Training zonder riem",
      "pet_trainer_other" : "Anders",
      "puppy_training" : "Puppytraining",
      "service_animal_training" : "Training van hulpdieren",
      "sport_trick_training" : "Sport- of tructraining",
      "training_other_animals" : "Training voor andere dieren",
      "corporate_photo" : "Zakelijk",
      "events_and_parties_photo" : "Evenementen en feesten",
      "family_and_group_photo" : "Gezin en groep",
      "headshots_and_portraits" : "Portretfoto's en portretten",
      "individual_photo" : "Persoonlijk",
      "maternity_and_newborn_photo" : "Zwangerschap en pasgeborene",
      "photographer_other" : "Anders",
      "product_photo" : "Product",
      "real_estate_photo" : "Onroerend goed",
      "school_portraits" : "Schoolportretten",
      "wedding_and_engagement_photo" : "Bruiloft en verloving",
      "find_leak" : "Lek opsporen en repareren",
      "install_faucet" : "Kraan installeren",
      "install_garbage_disposal" : "Vuilnisafvoer installeren",
      "install_shower" : "Douche installeren",
      "install_toilet" : "Toilet installeren",
      "install_water_heater" : "Waterverwarmer installeren",
      "plumbing_other" : "Anders",
      "repair_faucet" : "Kraan repareren",
      "repair_garbage_disposal" : "Afvalverwerker repareren",
      "repair_outdoor_systems" : "Buitensystemen repareren",
      "repair_pipe" : "Pijp repareren",
      "repair_sewer" : "Riolering repareren",
      "repair_shower" : "Douche repareren",
      "repair_toilet" : "Toilet repareren",
      "repair_water_heater" : "Waterverwarmer repareren",
      "unclog_drain" : "Afvoer ontstoppen",
      "commercial_pool_cleaning_maintenance" : "Commerciële zwembadreiniging en onderhoud",
      "equipment_maintenance_repair" : "Onderhoud en reparatie van apparatuur",
      "one_time_pool_cleaning" : "Eenmalige zwembadreiniging",
      "ongoing_pool_cleaning" : "Doorlopende zwembadreiniging",
      "pool_cleaner_other" : "Anders",
      "pool_cleaner_water_features" : "Waterpartijen",
      "seasonal_opening_closing" : "Seizoensopening en -sluiting",
      "spa_hot_tub_cleaning" : "Reiniging van spa's en bubbelbaden",
      "spa_hot_tub_repairs" : "Reparaties aan spa's en bubbelbaden",
      "tile_pool_wall_cleaning" : "Tegel- en zwembadwandreiniging",
      "water_testing_balancing" : "Water testen en balanceren",
      "jetted_lap_pools" : "Zwembaden met bubbelbad",
      "pool_construction" : "Zwembadconstructie",
      "pool_contractor_commercial_projects" : "Commerciële projecten",
      "pool_contractor_custom_designs" : "Aangepaste ontwerpen",
      "pool_contractor_other" : "Anders",
      "pool_contractor_renovation" : "Renovatie",
      "pool_contractor_repair_cracks" : "Scheuren repareren",
      "pool_contractor_repair_tile" : "Tegel repareren",
      "pool_contractor_resurfacing" : "Opnieuw aanleggen",
      "pool_contractor_water_features" : "Waterpartijen",
      "pool_hot_tub_equipment" : "Apparatuur voor zwembad en hottub",
      "spa_hot_tub_installation" : "Installatie van spa's en hottubs",
      "bilingual_programs" : "Tweetalige programma's",
      "early_preschool" : "Vroege kleuterschool",
      "full_day_preschool" : "Hele dag kleuterschool",
      "half_day_preschool" : "Halve dag kleuterschool",
      "kindergarten_classes" : "Kleuterklassen",
      "montessori_programs" : "Montessori-programma's",
      "play_based_preschool" : "Op spel gebaseerde kleuterschool",
      "preschool_infant_programs" : "Babyprogramma's",
      "preschool_other" : "Anders",
      "reggio_emilia_preschool" : "Reggio Emilia-kleuterschool",
      "special_needs_programs" : "Programma's voor speciale behoeften",
      "summer_camp" : "Zomerkamp",
      "waldorf_preschool" : "Waldorf-kleuterschool",
      "psychologist_other" : "Anders",
      "buyer_agent" : "Makelaar van de koper",
      "first_time_home_buyer" : "Koper eerste woning",
      "foreclosed_properties" : "In beslag genomen woningen",
      "luxury_properties" : "Luxe woningen",
      "new_construction" : "Nieuwbouw",
      "property_management" : "Vastgoedbeheer",
      "real_estate_agent_other" : "Anders",
      "relocation" : "Verhuizing",
      "rentals" : "Verhuur",
      "sellers_agent" : "Makelaar van de verkoper",
      "commercial_real_estate" : "Commercieel vastgoed",
      "easements" : "Erfdienstbaarheden",
      "encroachment" : "Inbreuk",
      "foreclosure_real_esate_lawyer" : "Executieverkoop",
      "landlord_tenant_law" : "Verhuurder- en huurdersrecht",
      "litigation_real_estate_lawyer" : "Procesvoering",
      "mortgage_lending_law" : "Hypotheek- en kredietrecht",
      "neighbor_hoa_disputes" : "Geschillen tussen buren en VvE's",
      "property_damage" : "Eigendomsschade",
      "purchase_agreements" : "Koopovereenkomsten",
      "real_estate_contracts_transactions" : "Vastgoedtransacties",
      "real_estate_lawyer_other" : "Anders",
      "residential_real_estate" : "Residentieel vastgoed",
      "title_services" : "Titeldiensten",
      "trespassing" : "Onrechtmatig betreden",
      "rehab_other" : "Anders",
      "attic_venting" : "Zolderventilatie",
      "gutter_installation" : "Gootinstallatie",
      "gutter_repair" : "Dakgootreparatie",
      "roof_inspection" : "Dakinspectie",
      "roof_installation" : "Dakinstallatie",
      "roof_repair" : "Dakreparatie",
      "roofer_other" : "Anders",
      "skylight_installation" : "Dakraaminstallatie",
      "skylight_repair" : "Dakraamreparatie",
      "storm_wind_damage_roof_repair" : "Schadeherstel aan dak",
      "sewage_cleaning" : "Schoonmaak",
      "sewage_excavation" : "Uitgraving",
      "sewage_inspection" : "Inspectie",
      "sewage_installation" : "Installatie",
      "sewage_locating" : "Lokaliseren",
      "sewage_maintenance_repairs" : "Onderhoud en reparaties",
      "sewage_pro_other" : "Anders",
      "sewage_pumping" : "Pompen",
      "sewage_removal_demolition" : "Verwijdering of Sloop",
      "remodeling_siding_pro" : "Verbouwing",
      "repair_maintenance_siding_pro" : "Reparatie en onderhoud",
      "siding_installation" : "Installatie van gevelbeplating",
      "siding_pro_other" : "Anders",
      "siding_removal" : "Gevelbeplating verwijderen",
      "smart_home_other" : "Anders",
      "commercial_snow_removal" : "Commerciële sneeuwruiming",
      "residential_plowing" : "Residentieel sneeuwruimen",
      "residential_shoveling_blowing" : "Residentieel scheppen en blazen",
      "salt_sand_deicing" : "Zout, zand en ontdooiing",
      "snow_relocation" : "Sneeuwverplaatsing",
      "snow_removal_other" : "Anders",
      "body_polish" : "Lichaam polijsten",
      "body_wrap" : "Lichaamspakking",
      "facial" : "Gezicht",
      "hydrotherapy" : "Hydrotherapie",
      "manicure" : "Manicure",
      "massage" : "Massage",
      "pedicure" : "Pedicure",
      "peels" : "Peels",
      "spa_other" : "Anders",
      "spa_packages" : "Spapakketten",
      "tanning" : "Zonnebank",
      "waxing" : "Waxen",
      "civil_tax_litigation" : "Civiele belastingrechtszaken",
      "corporate_taxes" : "Zakelijke belastingen",
      "criminal_tax_litigation" : "Strafrechtelijke belastinggeschillen",
      "estate_tax_planning" : "Planning voor vermogensbelasting",
      "failure_to_file" : "Niet indienen",
      "innocent_spouse_relief" : "Hulp voor onschuldige partner",
      "international_tax_services" : "Internationale belastingdiensten",
      "irs_tax_problems" : "Belastingproblemen IRS",
      "non_collectible_status" : "Niet-inbare status",
      "offer_in_compromise" : "Voorstel tot schikking",
      "tax_audits" : "Belastingcontroles",
      "tax_lawyer_other" : "Anders",
      "tax_liens_levies" : "Belastingbeslagen en -heffingen",
      "tax_planning_lawyer" : "Fiscale planning",
      "tax_relief" : "Belastingverlichting",
      "accounting_support" : "Boekhoudkundige ondersteuning",
      "business_incorporation_restructuring" : "Oprichting & herstructurering",
      "cryptocurrency_taxes" : "Cryptocurrency Belastingen",
      "irs_audit_representation" : "Vertegenwoordiging bij IRS-belastingcontrole",
      "irs_filing" : "IRS-aangifte",
      "irs_problem_consulting" : "Advies bij IRS-belastingproblemen",
      "new_business_services" : "Nieuwe zakelijke services",
      "payroll_support" : "Ondersteuning bij salarisadministratie",
      "tax_planning_tax_specialist" : "Fiscale planning",
      "tax_preparation" : "Voorbereiding belastingaangifte",
      "tax_problem_consulting_tax_specialist" : "Advies bij belastingproblemen",
      "tax_specialist_other" : "Anders",
      "therapist_other" : "Anders",
      "battery_service" : "Batterijservice",
      "car_towing" : "Auto wegslepen",
      "fuel_delivery" : "Brandstoflevering",
      "local_hauling" : "Lokaal transport",
      "long_distance_hauling" : "Langeafstandsvervoer",
      "motorcycle_towing" : "Wegslepen motorfiets",
      "special_vehicle_towing" : "Wegslepen speciaal voertuig",
      "tire_change" : "Banden verwisselen",
      "towing_other" : "Anders",
      "case_assessment_traffic_lawyer" : "Zaakevaluatie",
      "cdl_traffic_ticket" : "CDL-verkeersboete",
      "dui_dwi_traffic_lawyer" : "DUI",
      "fixit_ticket" : "Reparatiebon",
      "parking_ticket" : "Parkeerboete",
      "reckless_driving_traffic_lawyer" : "Roekeloos rijden",
      "red_light_ticket" : "Boete voor door rood licht rijden",
      "speeding_ticket" : "Snelheidsboete",
      "suspended_license" : "Opgeschorte licentie",
      "traffic_lawyer_other" : "Anders",
      "traffic_ticket" : "Verkeersboete",
      "cabling_and_bracing" : "Bekabeling en versteviging",
      "stump_removal" : "Verwijderen van boomstronken",
      "tree_planting" : "Bomen planten",
      "tree_removal" : "Boomverwijdering",
      "tree_service_other" : "Anders",
      "tree_transplanting" : "Boomverplanten",
      "tree_trimming_and_pruning" : "Bomen trimmen en snoeien",
      "tutor_computer_science" : "Informatica",
      "tutor_foreign_languages" : "Vreemde talen",
      "tutor_geography" : "Geografie",
      "tutor_government_and_economics" : "Overheid en Economie",
      "tutor_history" : "Geschiedenis",
      "tutor_homework_help" : "Hulp bij huiswerk",
      "tutor_math" : "Wiskunde",
      "tutor_other" : "Anders",
      "tutor_reading_and_writing" : "Lezen en schrijven",
      "tutor_science" : "Wetenschap",
      "tutor_special_education" : "Speciaal onderwijs",
      "tutor_test_pre_college_entrance" : "Toetsvoorbereiding: Toegang tot College",
      "tutor_test_prep_grad_school_entrance" : "Toetsvoorbereiding: Toegang tot Grad School",
      "tutor_test_prep_k8" : "Toetsvoorbereiding: Lager en middelbaar onderwijs",
      "area_rug_cleaning" : "Tapijtreiniging",
      "drapery_and_blind_cleaning" : "Gordijn- en jaloeziereiniging",
      "leather_cleaning" : "Leerreiniging",
      "mattress_cleaning" : "Matrasreiniging",
      "upholstery_cleaner_other" : "Anders",
      "upholstery_cleaning" : "Meubelreiniging",
      "upholstery_water_damage_cleanup" : "Waterschade opruimen",
      "bird_exotic_animal_care" : "Verzorging van vogels en exotische dieren",
      "farm_barn_animal_care" : "Boerderij- en schuurdierenverzorging",
      "microchipping" : "Microchippen",
      "veterinarian_allergies" : "Allergieën",
      "veterinarian_behavior_counseling" : "Gedragstherapie",
      "veterinarian_dental_care" : "Tandverzorging",
      "veterinarian_dermatology" : "Dermatologie",
      "veterinarian_emergency_care" : "Spoedeisende zorg",
      "veterinarian_end_of_life_care" : "Zorg aan het einde van het leven",
      "veterinarian_examinations" : "Examens",
      "veterinarian_nutrition_counseling" : "Voedingsadvies",
      "veterinarian_other" : "Anders",
      "veterinarian_preventive_care" : "Preventieve zorg",
      "veterinarian_spay_neuter" : "Steriliseren of castreren",
      "veterinarian_surgery" : "Chirurgie",
      "veterinarian_vaccinations" : "Vaccinaties",
      "aerial_videography" : "Luchtvideografie",
      "documentary_video_production" : "Documentaireproductie",
      "family_video_production" : "Familievideoproductie",
      "live_streaming" : "Live streamen",
      "photography" : "Fotografie",
      "product_demonstrations" : "Productdemonstratie",
      "promotional_video_production" : "Promotionele videoproductie",
      "real_estate_video_production" : "Videoproductie vastgoed",
      "special_event_video_production" : "Videoproductie voor speciale evenementen",
      "video_editing" : "Video bewerken",
      "videographer_other" : "Anders",
      "voice_overs" : "Voice-over",
      "wedding_video_production" : "Videoproductie bruiloft",
      "fire_damage_cleanup_repair" : "Brandschade opruimen/repareren",
      "water_damage_cleanup_repair" : "Waterschade opruimen",
      "water_damage_flooring" : "Vloeren",
      "water_damage_mold_inspection" : "Schimmelinspectie",
      "water_damage_mold_removal" : "Schimmelverwijdering",
      "water_damage_other" : "Anders",
      "water_damage_painting" : "Schilderen",
      "water_damage_pest_control" : "Ongediertebestrijding",
      "water_damage_plumbing" : "Sanitair",
      "water_damage_remodeling" : "Renovatie",
      "water_damage_roofing" : "Dakbedekking",
      "water_damage_sewage_cleanup" : "Rioolreiniging",
      "adult_weight_loss_programs" : "Programma's voor gewichtsverlies voor volwassenen",
      "diet_and_nutrition_counseling" : "Dieet- en voedingsadvies",
      "kids_weight_loss_programs" : "Programma's voor gewichtsverlies voor kinderen",
      "metabolic_testing" : "Metabolische tests",
      "weight_loss_consultation_and_training" : "Consultatie en training",
      "weight_loss_fitness_programs" : "Fitnessprogramma's",
      "weight_loss_meal_planning" : "Maaltijdplanning",
      "weight_loss_personal_training" : "Persoonlijke training",
      "weight_loss_service_other" : "Anders",
      "weight_loss_wellness_programs" : "Wellnessprogramma's",
      "glass_and_mirror_cleaning" : "Glas- en spiegelreiniging",
      "gutter_cleaning" : "Dakgootreiniging",
      "power_pressure_washing" : "Hogedrukreiniging",
      "rooftop_skylight_cleaning" : "Dak/dakraam schoonmaken",
      "window_cleaner_other" : "Anders",
      "window_cleaning" : "Glasbewassing",
      "door_installation" : "Deurinstallatie",
      "door_repair" : "Deurreparatie",
      "glass_installation" : "Glasinstallatie",
      "window_boardup" : "Boardup",
      "window_installation" : "Installatie van vensters",
      "window_repair" : "Reparatie van vensters",
      "window_repair_other" : "Anders",
      "install_new_wiper_blades" : "Nieuwe ruitenwisserbladen installeren",
      "repair_power_window" : "Elektrisch venster repareren",
      "repair_water_leak" : "Waterlek repareren",
      "repair_windshield" : "Voorruit repareren",
      "replace_rear_window" : "Achterruit vervangen",
      "replace_side_view_mirrors" : "Zijspiegels repareren",
      "replace_side_window" : "Zijraam vervangen",
      "replace_sunroof" : "Glas schuifdak vervangen",
      "replace_windshield" : "Voorruit vervangen",
      "windshield_other" : "Anders",
      "ashtanga" : "Ashtanga",
      "hatha" : "Hatha",
      "hot_yoga" : "Hot yoga",
      "iyengar" : "Iyengar",
      "kundalini" : "Kundalini",
      "meditation" : "Meditatie",
      "power_yoga" : "Poweryoga",
      "restorative" : "Herstellend",
      "vinyasa" : "Vinyasa",
      "yin" : "Yin",
      "yoga_instructor_other" : "Anders"
    }
  }
}
